import { b as _objectWithoutProperties, a as _toConsumableArray, _ as _objectSpread2 } from './_rollupPluginBabelHelpers-fb970440.js';
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Text } from 'quanta-ui';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';

var _excluded = ["setEnableRenew", "setValueChanges", "repeat", "repeatFormsReadOnly", "loadingPermCustAddr", "loadingCommCustAddr", "onPermAddrLookup", "onCommAddrLookup", "values", "validate", "getDomainData", "setFieldValue", "expandedCard", "setProposerDetailsCardToggle", "viewRenewPolicyData", "updateViewRenewPolicyData", "idProofTypeList", "customerTypeList", "maritalStatusList", "salutationList", "nationalityList", "organisationList", "genderList", "proposerDetails", "proposerDetailsMeta"];
function ProposerCustomerEditable(_ref) {
  var _validate, _validate$proposerDet, _validate2, _validate2$proposerDe, _expandedCard$current, _expandedCard$current2, _ciuTypeList, _ciuTypeList2, _expandedCard$current8, _expandedCard$current9, _proposerDetails$empl, _proposerDetails$empl2, _validate3, _validate3$proposerDe, _validate4, _validate4$proposerDe, _expandedCard$current15, _expandedCard$current16, _expandedCard$current22, _expandedCard$current23, _viewRenewPolicyData$, _viewRenewPolicyData$2, _props$productCode, _props$productCode2, _props$productCode3, _validate5, _validate5$proposerDe, _validate6, _validate6$proposerDe, _validate7, _validate7$proposerDe, _validate8, _validate8$proposerDe, _validate9, _validate9$proposerDe, _validate10, _validate10$proposerD, _expandedCard$current29, _expandedCard$current30, _viewRenewPolicyData$3, _viewRenewPolicyData$4, _props$productCode4, _props$productCode5, _props$productCode6, _validate11, _validate11$proposerD, _validate12, _validate12$proposerD, _validate13, _validate13$proposerD, _validate14, _validate14$proposerD, _validate15, _validate15$proposerD, _validate16, _validate16$proposerD, _values$proposerDetai27, _values$proposerDetai28, _values$proposerDetai29, _values$proposerDetai30, _values$proposerDetai31, _values$proposerDetai32, _values$proposerDetai33, _values$proposerDetai34, _validate17, _validate17$proposerD, _validate18, _validate18$proposerD, _expandedCard$current36, _expandedCard$current37, _expandedCard$current43, _expandedCard$current44, _validate19, _validate19$proposerD, _validate20, _validate20$proposerD;

  var setEnableRenew = _ref.setEnableRenew,
      setValueChanges = _ref.setValueChanges,
      repeat = _ref.repeat,
      repeatFormsReadOnly = _ref.repeatFormsReadOnly,
      loadingPermCustAddr = _ref.loadingPermCustAddr,
      loadingCommCustAddr = _ref.loadingCommCustAddr,
      onPermAddrLookup = _ref.onPermAddrLookup,
      onCommAddrLookup = _ref.onCommAddrLookup,
      values = _ref.values,
      validate = _ref.validate,
      getDomainData = _ref.getDomainData,
      setFieldValue = _ref.setFieldValue,
      expandedCard = _ref.expandedCard,
      setProposerDetailsCardToggle = _ref.setProposerDetailsCardToggle,
      viewRenewPolicyData = _ref.viewRenewPolicyData,
      updateViewRenewPolicyData = _ref.updateViewRenewPolicyData;
      _ref.idProofTypeList;
      var customerTypeList = _ref.customerTypeList,
      maritalStatusList = _ref.maritalStatusList,
      salutationList = _ref.salutationList,
      nationalityList = _ref.nationalityList,
      organisationList = _ref.organisationList,
      genderList = _ref.genderList,
      proposerDetails = _ref.proposerDetails,
      proposerDetailsMeta = _ref.proposerDetailsMeta,
      props = _objectWithoutProperties(_ref, _excluded);

  var proposerCustomerData = proposerDetails ? [
  /*SA CR P2_169A: Made editable for COnfig IMD */
  !(values !== null && values !== void 0 && values.isConfigImd) ? {
    grid_type: 'data',
    grid_data: [{
      label: 'Customer Number',
      text: proposerDetails === null || proposerDetails === void 0 ? void 0 : proposerDetails.id
    }, {
      label: 'CRN',
      text: proposerDetailsMeta === null || proposerDetailsMeta === void 0 ? void 0 : proposerDetailsMeta.crn
    }]
  } : {
    title: /*#__PURE__*/React.createElement(Text, {
      type: "normal",
      className: 'font-semibold'
    }, "Basic Details"),
    grid_type: 'input',
    clickToEdit: true,
    resetOnCancel: false,
    isBorderRequired: true,
    editDisplayDisabled: viewRenewPolicyData === null || viewRenewPolicyData === void 0 ? void 0 : viewRenewPolicyData.isProposalRenewed,
    disableSubmit: (values === null || values === void 0 ? void 0 : values.isCalculatingPremium) || ((_validate = validate(values)) === null || _validate === void 0 ? void 0 : (_validate$proposerDet = _validate.proposerDetailsMeta) === null || _validate$proposerDet === void 0 ? void 0 : _validate$proposerDet.crn) !== undefined || ((_validate2 = validate(values)) === null || _validate2 === void 0 ? void 0 : (_validate2$proposerDe = _validate2.proposerDetailsMeta) === null || _validate2$proposerDe === void 0 ? void 0 : _validate2$proposerDe.ciuType) !== undefined,
    disableEdit: values === null || values === void 0 ? void 0 : values.isCalculatingPremium,
    disableCancel: values === null || values === void 0 ? void 0 : values.isCalculatingPremium,
    borderClassName: 'border-t-2 border-neutral pt-2',
    initDisplayEdit: viewRenewPolicyData !== null && viewRenewPolicyData !== void 0 && viewRenewPolicyData.isProposalRenewed ? false : (_expandedCard$current = expandedCard.current.find(function (exp) {
      return (exp === null || exp === void 0 ? void 0 : exp.cardName) === 'proposerDetails';
    })) === null || _expandedCard$current === void 0 ? void 0 : (_expandedCard$current2 = _expandedCard$current.subSections) === null || _expandedCard$current2 === void 0 ? void 0 : _expandedCard$current2.includes('crnDetails'),
    onValueChanges: function onValueChanges(values) {
      setValueChanges(values);
    },
    onEdit: function onEdit(_) {
      var _expandedCard$current3;

      setEnableRenew(false);
      setFieldValue("countEditsOpen", (values === null || values === void 0 ? void 0 : values.countEditsOpen) + 1);
      expandedCard.current = [].concat(_toConsumableArray(expandedCard.current.filter(function (exp) {
        return (exp === null || exp === void 0 ? void 0 : exp.cardName) !== 'proposerDetails';
      })), [_objectSpread2(_objectSpread2({}, expandedCard.current.find(function (exp) {
        return (exp === null || exp === void 0 ? void 0 : exp.cardName) === 'proposerDetails';
      })), {}, {
        cardFlag: true,
        subSections: [].concat(_toConsumableArray((_expandedCard$current3 = expandedCard.current.find(function (exp) {
          return (exp === null || exp === void 0 ? void 0 : exp.cardName) === 'proposerDetails';
        })) === null || _expandedCard$current3 === void 0 ? void 0 : _expandedCard$current3.subSections), ['crnDetails'])
      })]);

      if (props.forwardedAlertsRef && props.forwardedAlertsRef.current) {
        props.forwardedAlertsRef.current = [];
      }

      updateViewRenewPolicyData({
        isProposalReadyForRenewal: false
      });
      setProposerDetailsCardToggle(false);
    },
    onCancel: function onCancel(_, valuesBeforeEdit) {
      var _valuesBeforeEdit$pro, _valuesBeforeEdit$pro2, _expandedCard$current4, _expandedCard$current5;

      if ((values === null || values === void 0 ? void 0 : values.countEditsOpen) === 1) {
        updateViewRenewPolicyData({
          isProposalReadyForRenewal: true
        });
        setEnableRenew(true);
      }

      setFieldValue("countEditsOpen", (values === null || values === void 0 ? void 0 : values.countEditsOpen) - 1);
      setFieldValue("proposerDetailsMeta.ciuType", valuesBeforeEdit === null || valuesBeforeEdit === void 0 ? void 0 : (_valuesBeforeEdit$pro = valuesBeforeEdit.proposerDetailsMeta) === null || _valuesBeforeEdit$pro === void 0 ? void 0 : _valuesBeforeEdit$pro.ciuType);
      setFieldValue("proposerDetailsMeta.crn", valuesBeforeEdit === null || valuesBeforeEdit === void 0 ? void 0 : (_valuesBeforeEdit$pro2 = valuesBeforeEdit.proposerDetailsMeta) === null || _valuesBeforeEdit$pro2 === void 0 ? void 0 : _valuesBeforeEdit$pro2.crn);
      expandedCard.current = [].concat(_toConsumableArray(expandedCard.current.filter(function (exp) {
        return (exp === null || exp === void 0 ? void 0 : exp.cardName) !== 'proposerDetails';
      })), [_objectSpread2(_objectSpread2({}, expandedCard.current.find(function (exp) {
        return (exp === null || exp === void 0 ? void 0 : exp.cardName) === 'proposerDetails';
      })), {}, {
        cardFlag: false,
        subSections: _toConsumableArray((_expandedCard$current4 = expandedCard.current.find(function (exp) {
          return (exp === null || exp === void 0 ? void 0 : exp.cardName) === 'proposerDetails';
        })) === null || _expandedCard$current4 === void 0 ? void 0 : (_expandedCard$current5 = _expandedCard$current4.subSections) === null || _expandedCard$current5 === void 0 ? void 0 : _expandedCard$current5.filter(function (subSection) {
          return subSection !== 'crnDetails';
        }))
      })]);

      if (props.forwardedAlertsRef && props.forwardedAlertsRef.current) {
        props.forwardedAlertsRef.current = [];
      }

      setProposerDetailsCardToggle(true);
    },
    onSave: function onSave(_) {
      var _expandedCard$current6, _expandedCard$current7;

      if ((values === null || values === void 0 ? void 0 : values.countEditsOpen) === 1) {
        updateViewRenewPolicyData({
          isProposalReadyForRenewal: true
        });
        setEnableRenew(true);
      }

      setFieldValue("countEditsOpen", (values === null || values === void 0 ? void 0 : values.countEditsOpen) - 1);
      expandedCard.current = [].concat(_toConsumableArray(expandedCard.current.filter(function (exp) {
        return (exp === null || exp === void 0 ? void 0 : exp.cardName) !== 'proposerDetails';
      })), [_objectSpread2(_objectSpread2({}, expandedCard.current.find(function (exp) {
        return (exp === null || exp === void 0 ? void 0 : exp.cardName) === 'proposerDetails';
      })), {}, {
        cardFlag: false,
        subSections: _toConsumableArray((_expandedCard$current6 = expandedCard.current.find(function (exp) {
          return (exp === null || exp === void 0 ? void 0 : exp.cardName) === 'proposerDetails';
        })) === null || _expandedCard$current6 === void 0 ? void 0 : (_expandedCard$current7 = _expandedCard$current6.subSections) === null || _expandedCard$current7 === void 0 ? void 0 : _expandedCard$current7.filter(function (subSection) {
          return subSection !== 'crnDetails';
        }))
      })]);

      if (props.forwardedAlertsRef && props.forwardedAlertsRef.current) {
        props.forwardedAlertsRef.current = [];
      }

      setProposerDetailsCardToggle(true);
    },
    grid_data: [{
      type: 'text',
      min: 0,
      onKeyDown: function onKeyDown(evt) {
        return evt.key === 'e' && evt.preventDefault();
      },
      label: /*#__PURE__*/React.createElement("div", null, "Customer Number ", /*#__PURE__*/React.createElement(Text, {
        severity: "error"
      })),
      labelReadOnly: /*#__PURE__*/React.createElement("div", null, "Customer Number ", /*#__PURE__*/React.createElement(Text, {
        severity: "error"
      })),
      name: 'proposerDetails.id',
      disabled: true
    }, {
      type: 'select',
      min: 0,
      onKeyDown: function onKeyDown(evt) {
        return evt.key === 'e' && evt.preventDefault();
      },
      label: values !== null && values !== void 0 && values.isConfigImd ? /*#__PURE__*/React.createElement("div", null, "CIU Type ", /*#__PURE__*/React.createElement(Text, {
        severity: "error"
      }, "*")) : /*#__PURE__*/React.createElement("div", null, "CIU Type ", /*#__PURE__*/React.createElement(Text, {
        severity: "error"
      })),
      labelReadOnly: /*#__PURE__*/React.createElement("div", null, "CIU Type ", /*#__PURE__*/React.createElement(Text, {
        severity: "error"
      })),
      data: ciuTypeList && ((_ciuTypeList = ciuTypeList) === null || _ciuTypeList === void 0 ? void 0 : _ciuTypeList.length) > 0 ? _toConsumableArray((_ciuTypeList2 = ciuTypeList) === null || _ciuTypeList2 === void 0 ? void 0 : _ciuTypeList2.map(function (data) {
        return {
          label: data.code,
          value: data.value
        };
      })) : [],
      name: 'proposerDetailsMeta.ciuType',
      disabled: values === null || values === void 0 ? void 0 : values.isCalculatingPremium
    }, {
      type: 'text',
      max: 25,
      label: values !== null && values !== void 0 && values.isConfigImd ? /*#__PURE__*/React.createElement("div", null, "CRN Number ", /*#__PURE__*/React.createElement(Text, {
        severity: "error"
      }, "*")) : /*#__PURE__*/React.createElement("div", null, "CRN Number ", /*#__PURE__*/React.createElement(Text, {
        severity: "error"
      })),
      labelReadOnly: /*#__PURE__*/React.createElement("div", null, "CRN Number  ", /*#__PURE__*/React.createElement(Text, {
        severity: "error"
      })),
      name: 'proposerDetailsMeta.crn',
      disabled: values === null || values === void 0 ? void 0 : values.isCalculatingPremium
    }].filter(function (d) {
      return d;
    })
  },
  /*SA CR P2_169A:  COnfig IMD */
  (proposerDetails === null || proposerDetails === void 0 ? void 0 : proposerDetails.customerType) === getDomainData(customerTypeList, 'Individual', 'value', 'code') ? {
    title: /*#__PURE__*/React.createElement(Text, {
      type: "normal",
      className: 'font-semibold'
    }, "Personal Details"),
    grid_type: 'data',
    isBorderRequired: true,
    borderClassName: 'border-t-2 border-neutral pt-4',
    grid_data: [{
      label: 'Title',
      text: getDomainData(salutationList, proposerDetails === null || proposerDetails === void 0 ? void 0 : proposerDetails.title, 'code', 'value')
    }, {
      label: 'Gender',
      text: getDomainData(genderList, proposerDetails === null || proposerDetails === void 0 ? void 0 : proposerDetails.gender, 'code', 'value')
    }, {
      label: 'Date of Birth',
      text: proposerDetails === null || proposerDetails === void 0 ? void 0 : proposerDetails.proposerDOB
    }, {
      label: 'First Name',
      text: proposerDetails === null || proposerDetails === void 0 ? void 0 : proposerDetails.firstName
    }, {
      label: 'Middle Name',
      text: proposerDetails === null || proposerDetails === void 0 ? void 0 : proposerDetails.middleName
    }, {
      label: 'Last Name',
      text: proposerDetails === null || proposerDetails === void 0 ? void 0 : proposerDetails.lastName
    }, {
      label: 'Marital Status',
      text: getDomainData(maritalStatusList, proposerDetails === null || proposerDetails === void 0 ? void 0 : proposerDetails.maritalStatus, 'code', 'value')
    }, {
      label: 'Nationality',
      text: getDomainData(nationalityList, proposerDetails === null || proposerDetails === void 0 ? void 0 : proposerDetails.nationality, 'code', 'value')
    },
    /*SADivya -CR P2_233 : KYC*/
    {
      label: "Mother's Maiden Name",
      text: proposerDetails === null || proposerDetails === void 0 ? void 0 : proposerDetails.motherMaidenName
    }, {
      label: 'CKYC ID Number',
      text: proposerDetails === null || proposerDetails === void 0 ? void 0 : proposerDetails.ckycIdNumber
    }, {
      label: 'EIA Required',
      text: proposerDetails === null || proposerDetails === void 0 ? void 0 : proposerDetails.eiaRequired
    }, {
      label: 'EIA Number',
      text: proposerDetails === null || proposerDetails === void 0 ? void 0 : proposerDetails.eiaNumber
    }
    /*SADivya -CR P2_233 : KYC*/
    ]
  } : {
    title: /*#__PURE__*/React.createElement(Text, {
      type: "normal",
      className: 'font-semibold'
    }, "Organisation Details"),
    grid_type: 'data',
    isBorderRequired: true,
    borderClassName: 'border-t-2 border-neutral pt-4',
    grid_data: [{
      label: 'Organisation Name',
      text: proposerDetails === null || proposerDetails === void 0 ? void 0 : proposerDetails.orgName
    }, {
      label: 'Organisation Type ',
      text: getDomainData(organisationList, proposerDetails === null || proposerDetails === void 0 ? void 0 : proposerDetails.orgType, 'code', 'value')
    }, {
      label: 'Contact Person Name',
      maxLength: 40,
      text: proposerDetails === null || proposerDetails === void 0 ? void 0 : proposerDetails.contactName
    }]
  }, proposerDetails.customerType !== getDomainData(customerTypeList, 'Individual', 'value', 'code') ? {
    title: /*#__PURE__*/React.createElement(Text, {
      type: "normal",
      className: 'font-semibold'
    }, "Tax Identification Details"),
    grid_type: 'input',
    clickToEdit: true,
    resetOnCancel: false,
    isBorderRequired: true,
    editDisplayDisabled: viewRenewPolicyData === null || viewRenewPolicyData === void 0 ? void 0 : viewRenewPolicyData.isProposalRenewed,
    disableSubmit: values === null || values === void 0 ? void 0 : values.isCalculatingPremium,
    // ||
    // validate(values)?.proposerDetails?.panNumber !==
    // undefined ||
    // validate(values)?.proposerDetails?.gstNumber !==
    // undefined,
    disableEdit: values === null || values === void 0 ? void 0 : values.isCalculatingPremium,
    disableCancel: values === null || values === void 0 ? void 0 : values.isCalculatingPremium,
    borderClassName: 'border-t-2 border-neutral pt-2',
    initDisplayEdit: viewRenewPolicyData !== null && viewRenewPolicyData !== void 0 && viewRenewPolicyData.isProposalRenewed ? false : (_expandedCard$current8 = expandedCard.current.find(function (exp) {
      return (exp === null || exp === void 0 ? void 0 : exp.cardName) === 'proposerDetails';
    })) === null || _expandedCard$current8 === void 0 ? void 0 : (_expandedCard$current9 = _expandedCard$current8.subSections) === null || _expandedCard$current9 === void 0 ? void 0 : _expandedCard$current9.includes('taxIdentificationDetails'),
    onValueChanges: function onValueChanges(values) {
      setValueChanges(values);
    },
    onEdit: function onEdit(_) {
      var _expandedCard$current10;

      setEnableRenew(false);
      setFieldValue("countEditsOpen", (values === null || values === void 0 ? void 0 : values.countEditsOpen) + 1);
      expandedCard.current = [].concat(_toConsumableArray(expandedCard.current.filter(function (exp) {
        return (exp === null || exp === void 0 ? void 0 : exp.cardName) !== 'proposerDetails';
      })), [_objectSpread2(_objectSpread2({}, expandedCard.current.find(function (exp) {
        return (exp === null || exp === void 0 ? void 0 : exp.cardName) === 'proposerDetails';
      })), {}, {
        cardFlag: true,
        subSections: [].concat(_toConsumableArray((_expandedCard$current10 = expandedCard.current.find(function (exp) {
          return (exp === null || exp === void 0 ? void 0 : exp.cardName) === 'proposerDetails';
        })) === null || _expandedCard$current10 === void 0 ? void 0 : _expandedCard$current10.subSections), ['taxIdentificationDetails'])
      })]);

      if (props.forwardedAlertsRef && props.forwardedAlertsRef.current) {
        props.forwardedAlertsRef.current = [];
      }

      updateViewRenewPolicyData({
        isProposalReadyForRenewal: false
      });
      setProposerDetailsCardToggle(false);
    },
    onCancel: function onCancel(_, valuesBeforeEdit) {
      var _valuesBeforeEdit$pro3, _valuesBeforeEdit$pro4, _valuesBeforeEdit$pro5, _valuesBeforeEdit$pro6, _valuesBeforeEdit$pro7, _valuesBeforeEdit$pro8, _valuesBeforeEdit$pro9, _expandedCard$current11, _expandedCard$current12;

      if ((values === null || values === void 0 ? void 0 : values.countEditsOpen) === 1) {
        updateViewRenewPolicyData({
          isProposalReadyForRenewal: true
        });
        setEnableRenew(true);
      }

      setFieldValue("countEditsOpen", (values === null || values === void 0 ? void 0 : values.countEditsOpen) - 1);
      setFieldValue("proposerDetails.panNumber", valuesBeforeEdit === null || valuesBeforeEdit === void 0 ? void 0 : (_valuesBeforeEdit$pro3 = valuesBeforeEdit.proposerDetails) === null || _valuesBeforeEdit$pro3 === void 0 ? void 0 : _valuesBeforeEdit$pro3.panNumber);
      setFieldValue("proposerDetails.tanNumber", valuesBeforeEdit === null || valuesBeforeEdit === void 0 ? void 0 : (_valuesBeforeEdit$pro4 = valuesBeforeEdit.proposerDetails) === null || _valuesBeforeEdit$pro4 === void 0 ? void 0 : _valuesBeforeEdit$pro4.tanNumber);
      setFieldValue("proposerDetails.gstNumber", valuesBeforeEdit === null || valuesBeforeEdit === void 0 ? void 0 : (_valuesBeforeEdit$pro5 = valuesBeforeEdit.proposerDetails) === null || _valuesBeforeEdit$pro5 === void 0 ? void 0 : _valuesBeforeEdit$pro5.gstNumber);
      setFieldValue("proposerDetails.regNumber", valuesBeforeEdit === null || valuesBeforeEdit === void 0 ? void 0 : (_valuesBeforeEdit$pro6 = valuesBeforeEdit.proposerDetails) === null || _valuesBeforeEdit$pro6 === void 0 ? void 0 : _valuesBeforeEdit$pro6.regNumber);
      setFieldValue("proposerDetails.certificateOfInCorporation", valuesBeforeEdit === null || valuesBeforeEdit === void 0 ? void 0 : (_valuesBeforeEdit$pro7 = valuesBeforeEdit.proposerDetails) === null || _valuesBeforeEdit$pro7 === void 0 ? void 0 : _valuesBeforeEdit$pro7.certificateOfInCorporation);
      setFieldValue("proposerDetails.udyogAadhaarNumber", valuesBeforeEdit === null || valuesBeforeEdit === void 0 ? void 0 : (_valuesBeforeEdit$pro8 = valuesBeforeEdit.proposerDetails) === null || _valuesBeforeEdit$pro8 === void 0 ? void 0 : _valuesBeforeEdit$pro8.udyogAadhaarNumber);
      setFieldValue("proposerDetails.ckycIdNumber", valuesBeforeEdit === null || valuesBeforeEdit === void 0 ? void 0 : (_valuesBeforeEdit$pro9 = valuesBeforeEdit.proposerDetails) === null || _valuesBeforeEdit$pro9 === void 0 ? void 0 : _valuesBeforeEdit$pro9.ckycIdNumber);
      expandedCard.current = [].concat(_toConsumableArray(expandedCard.current.filter(function (exp) {
        return (exp === null || exp === void 0 ? void 0 : exp.cardName) !== 'proposerDetails';
      })), [_objectSpread2(_objectSpread2({}, expandedCard.current.find(function (exp) {
        return (exp === null || exp === void 0 ? void 0 : exp.cardName) === 'proposerDetails';
      })), {}, {
        cardFlag: false,
        subSections: _toConsumableArray((_expandedCard$current11 = expandedCard.current.find(function (exp) {
          return (exp === null || exp === void 0 ? void 0 : exp.cardName) === 'proposerDetails';
        })) === null || _expandedCard$current11 === void 0 ? void 0 : (_expandedCard$current12 = _expandedCard$current11.subSections) === null || _expandedCard$current12 === void 0 ? void 0 : _expandedCard$current12.filter(function (subSection) {
          return subSection !== 'taxIdentificationDetails';
        }))
      })]);

      if (props.forwardedAlertsRef && props.forwardedAlertsRef.current) {
        props.forwardedAlertsRef.current = [];
      }

      setProposerDetailsCardToggle(true);
    },
    onSave: function onSave(_) {
      var _expandedCard$current13, _expandedCard$current14;

      if ((values === null || values === void 0 ? void 0 : values.countEditsOpen) === 1) {
        updateViewRenewPolicyData({
          isProposalReadyForRenewal: true
        });
        setEnableRenew(true);
      }

      setFieldValue("countEditsOpen", (values === null || values === void 0 ? void 0 : values.countEditsOpen) - 1);
      expandedCard.current = [].concat(_toConsumableArray(expandedCard.current.filter(function (exp) {
        return (exp === null || exp === void 0 ? void 0 : exp.cardName) !== 'proposerDetails';
      })), [_objectSpread2(_objectSpread2({}, expandedCard.current.find(function (exp) {
        return (exp === null || exp === void 0 ? void 0 : exp.cardName) === 'proposerDetails';
      })), {}, {
        cardFlag: false,
        subSections: _toConsumableArray((_expandedCard$current13 = expandedCard.current.find(function (exp) {
          return (exp === null || exp === void 0 ? void 0 : exp.cardName) === 'proposerDetails';
        })) === null || _expandedCard$current13 === void 0 ? void 0 : (_expandedCard$current14 = _expandedCard$current13.subSections) === null || _expandedCard$current14 === void 0 ? void 0 : _expandedCard$current14.filter(function (subSection) {
          return subSection !== 'taxIdentificationDetails';
        }))
      })]);

      if (props.forwardedAlertsRef && props.forwardedAlertsRef.current) {
        props.forwardedAlertsRef.current = [];
      }

      setProposerDetailsCardToggle(true);
    },
    grid_data: [{
      type: 'text',
      min: 0,
      className: 'uppercase',
      onKeyDown: function onKeyDown(evt) {
        return evt.key === 'e' && evt.preventDefault();
      },
      label: /*#__PURE__*/React.createElement("div", null, "Registration Number", /*#__PURE__*/React.createElement(Text, {
        severity: "error"
      }, "*")),
      labelReadOnly: /*#__PURE__*/React.createElement("div", null, "Registration Number ", /*#__PURE__*/React.createElement(Text, {
        severity: "error"
      })),
      name: 'proposerDetails.regNumber',
      disabled: values === null || values === void 0 ? void 0 : values.isCalculatingPremium
    }, {
      type: 'text',
      min: 0,
      className: 'uppercase',
      onKeyDown: function onKeyDown(evt) {
        return evt.key === 'e' && evt.preventDefault();
      },
      label: /*#__PURE__*/React.createElement("div", null, "TAN Number", /*#__PURE__*/React.createElement(Text, {
        severity: "error"
      }, "*")),
      labelReadOnly: /*#__PURE__*/React.createElement("div", null, "TAN Number ", /*#__PURE__*/React.createElement(Text, {
        severity: "error"
      })),
      name: 'proposerDetails.tanNumber',
      disabled: values === null || values === void 0 ? void 0 : values.isCalculatingPremium
    }, {
      type: 'text',
      min: 0,
      className: 'uppercase',
      onKeyDown: function onKeyDown(evt) {
        return evt.key === 'e' && evt.preventDefault();
      },
      label: /*#__PURE__*/React.createElement("div", null, "GST Number", /*#__PURE__*/React.createElement(Text, {
        severity: "error"
      }, "*")),
      labelReadOnly: /*#__PURE__*/React.createElement("div", null, "GST Number ", /*#__PURE__*/React.createElement(Text, {
        severity: "error"
      })),
      name: 'proposerDetails.gstNumber',
      disabled: values === null || values === void 0 ? void 0 : values.isCalculatingPremium
    }, {
      type: 'text',
      min: 0,
      className: 'uppercase',
      onKeyDown: function onKeyDown(evt) {
        return evt.key === 'e' && evt.preventDefault();
      },
      label: /*#__PURE__*/React.createElement("div", null, "PAN Card Number", /*#__PURE__*/React.createElement(Text, {
        severity: "error"
      }, "*")),
      labelReadOnly: /*#__PURE__*/React.createElement("div", null, "PAN Card Number ", /*#__PURE__*/React.createElement(Text, {
        severity: "error"
      })),
      name: 'proposerDetails.panNumber',
      disabled: values === null || values === void 0 ? void 0 : values.isCalculatingPremium
    }, {
      type: 'text',
      min: 0,
      className: 'uppercase',
      onKeyDown: function onKeyDown(evt) {
        return evt.key === 'e' && evt.preventDefault();
      },
      label: /*#__PURE__*/React.createElement("div", null, "Certificate of Incorporation", /*#__PURE__*/React.createElement(Text, {
        severity: "error"
      }, "*")),
      labelReadOnly: /*#__PURE__*/React.createElement("div", null, "Certificate of Incorporation ", /*#__PURE__*/React.createElement(Text, {
        severity: "error"
      })),
      name: 'proposerDetails.certificateOfInCorporation',
      disabled: values === null || values === void 0 ? void 0 : values.isCalculatingPremium
    }, {
      type: 'text',
      min: 0,
      className: 'uppercase',
      onKeyDown: function onKeyDown(evt) {
        return evt.key === 'e' && evt.preventDefault();
      },
      label: /*#__PURE__*/React.createElement("div", null, "udyog Aadhaar number", /*#__PURE__*/React.createElement(Text, {
        severity: "error"
      }, "*")),
      labelReadOnly: /*#__PURE__*/React.createElement("div", null, "udyog Aadhaar number ", /*#__PURE__*/React.createElement(Text, {
        severity: "error"
      })),
      name: 'proposerDetails.udyogAadhaarNumber',
      disabled: values === null || values === void 0 ? void 0 : values.isCalculatingPremium
    }, {
      type: 'text',
      min: 0,
      className: 'uppercase',
      onKeyDown: function onKeyDown(evt) {
        return evt.key === 'e' && evt.preventDefault();
      },
      label: /*#__PURE__*/React.createElement("div", null, "CKYC ID Number", /*#__PURE__*/React.createElement(Text, {
        severity: "error"
      }, "*")),
      labelReadOnly: /*#__PURE__*/React.createElement("div", null, "CKYC ID Number ", /*#__PURE__*/React.createElement(Text, {
        severity: "error"
      })),
      name: 'proposerDetails.ckycIdNumber',
      disabled: values === null || values === void 0 ? void 0 : values.isCalculatingPremium
    }
    /*EADivya -CR P2_233 : KYC*/
    ]
  } : null, proposerDetails.customerType === getDomainData(customerTypeList, 'Individual', 'value', 'code') ? {
    title: /*#__PURE__*/React.createElement(Text, {
      type: "normal",
      className: 'font-semibold'
    }, "Internal Employee"),
    grid_type: 'data',
    isBorderRequired: true,
    borderClassName: 'border-t-2 border-neutral pt-4',
    grid_data: [{
      label: 'Employee Number',
      text: proposerDetails === null || proposerDetails === void 0 ? void 0 : (_proposerDetails$empl = proposerDetails.employeeNumber) === null || _proposerDetails$empl === void 0 ? void 0 : (_proposerDetails$empl2 = _proposerDetails$empl.toString()) === null || _proposerDetails$empl2 === void 0 ? void 0 : _proposerDetails$empl2.toUpperCase()
    }].filter(function (d) {
      return d;
    })
  } : null, proposerDetails.customerType === getDomainData(customerTypeList, 'Individual', 'value', 'code') ? {
    title: /*#__PURE__*/React.createElement(Text, {
      type: "normal",
      className: 'font-semibold'
    }, "Tax Identification Details"),
    grid_type: 'input',
    clickToEdit: true,
    resetOnCancel: false,
    isBorderRequired: true,
    editDisplayDisabled: viewRenewPolicyData === null || viewRenewPolicyData === void 0 ? void 0 : viewRenewPolicyData.isProposalRenewed,
    disableSubmit: (values === null || values === void 0 ? void 0 : values.isCalculatingPremium) || ((_validate3 = validate(values)) === null || _validate3 === void 0 ? void 0 : (_validate3$proposerDe = _validate3.proposerDetails) === null || _validate3$proposerDe === void 0 ? void 0 : _validate3$proposerDe.panNumber) !== undefined || ((_validate4 = validate(values)) === null || _validate4 === void 0 ? void 0 : (_validate4$proposerDe = _validate4.proposerDetails) === null || _validate4$proposerDe === void 0 ? void 0 : _validate4$proposerDe.gstNumber) !== undefined,
    disableEdit: values === null || values === void 0 ? void 0 : values.isCalculatingPremium,
    disableCancel: values === null || values === void 0 ? void 0 : values.isCalculatingPremium,
    borderClassName: 'border-t-2 border-neutral pt-2',
    initDisplayEdit: viewRenewPolicyData !== null && viewRenewPolicyData !== void 0 && viewRenewPolicyData.isProposalRenewed ? false : (_expandedCard$current15 = expandedCard.current.find(function (exp) {
      return (exp === null || exp === void 0 ? void 0 : exp.cardName) === 'proposerDetails';
    })) === null || _expandedCard$current15 === void 0 ? void 0 : (_expandedCard$current16 = _expandedCard$current15.subSections) === null || _expandedCard$current16 === void 0 ? void 0 : _expandedCard$current16.includes('taxIdentificationDetails'),
    onValueChanges: function onValueChanges(values) {
      setValueChanges(values);
    },
    onEdit: function onEdit(_) {
      var _expandedCard$current17;

      setEnableRenew(false);
      setFieldValue("countEditsOpen", (values === null || values === void 0 ? void 0 : values.countEditsOpen) + 1);
      expandedCard.current = [].concat(_toConsumableArray(expandedCard.current.filter(function (exp) {
        return (exp === null || exp === void 0 ? void 0 : exp.cardName) !== 'proposerDetails';
      })), [_objectSpread2(_objectSpread2({}, expandedCard.current.find(function (exp) {
        return (exp === null || exp === void 0 ? void 0 : exp.cardName) === 'proposerDetails';
      })), {}, {
        cardFlag: true,
        subSections: [].concat(_toConsumableArray((_expandedCard$current17 = expandedCard.current.find(function (exp) {
          return (exp === null || exp === void 0 ? void 0 : exp.cardName) === 'proposerDetails';
        })) === null || _expandedCard$current17 === void 0 ? void 0 : _expandedCard$current17.subSections), ['taxIdentificationDetails'])
      })]);

      if (props.forwardedAlertsRef && props.forwardedAlertsRef.current) {
        props.forwardedAlertsRef.current = [];
      }

      updateViewRenewPolicyData({
        isProposalReadyForRenewal: false
      });
      setProposerDetailsCardToggle(false);
    },
    onCancel: function onCancel(_, valuesBeforeEdit) {
      var _valuesBeforeEdit$pro10, _valuesBeforeEdit$pro11, _expandedCard$current18, _expandedCard$current19;

      if ((values === null || values === void 0 ? void 0 : values.countEditsOpen) === 1) {
        updateViewRenewPolicyData({
          isProposalReadyForRenewal: true
        });
        setEnableRenew(true);
      }

      setFieldValue("countEditsOpen", (values === null || values === void 0 ? void 0 : values.countEditsOpen) - 1);
      setFieldValue("proposerDetails.panNumber", valuesBeforeEdit === null || valuesBeforeEdit === void 0 ? void 0 : (_valuesBeforeEdit$pro10 = valuesBeforeEdit.proposerDetails) === null || _valuesBeforeEdit$pro10 === void 0 ? void 0 : _valuesBeforeEdit$pro10.panNumber);
      setFieldValue("proposerDetails.gstNumber", valuesBeforeEdit === null || valuesBeforeEdit === void 0 ? void 0 : (_valuesBeforeEdit$pro11 = valuesBeforeEdit.proposerDetails) === null || _valuesBeforeEdit$pro11 === void 0 ? void 0 : _valuesBeforeEdit$pro11.gstNumber);
      expandedCard.current = [].concat(_toConsumableArray(expandedCard.current.filter(function (exp) {
        return (exp === null || exp === void 0 ? void 0 : exp.cardName) !== 'proposerDetails';
      })), [_objectSpread2(_objectSpread2({}, expandedCard.current.find(function (exp) {
        return (exp === null || exp === void 0 ? void 0 : exp.cardName) === 'proposerDetails';
      })), {}, {
        cardFlag: false,
        subSections: _toConsumableArray((_expandedCard$current18 = expandedCard.current.find(function (exp) {
          return (exp === null || exp === void 0 ? void 0 : exp.cardName) === 'proposerDetails';
        })) === null || _expandedCard$current18 === void 0 ? void 0 : (_expandedCard$current19 = _expandedCard$current18.subSections) === null || _expandedCard$current19 === void 0 ? void 0 : _expandedCard$current19.filter(function (subSection) {
          return subSection !== 'taxIdentificationDetails';
        }))
      })]);

      if (props.forwardedAlertsRef && props.forwardedAlertsRef.current) {
        props.forwardedAlertsRef.current = [];
      }

      setProposerDetailsCardToggle(true);
    },
    onSave: function onSave(_) {
      var _expandedCard$current20, _expandedCard$current21;

      if ((values === null || values === void 0 ? void 0 : values.countEditsOpen) === 1) {
        updateViewRenewPolicyData({
          isProposalReadyForRenewal: true
        });
        setEnableRenew(true);
      }

      setFieldValue("countEditsOpen", (values === null || values === void 0 ? void 0 : values.countEditsOpen) - 1);
      expandedCard.current = [].concat(_toConsumableArray(expandedCard.current.filter(function (exp) {
        return (exp === null || exp === void 0 ? void 0 : exp.cardName) !== 'proposerDetails';
      })), [_objectSpread2(_objectSpread2({}, expandedCard.current.find(function (exp) {
        return (exp === null || exp === void 0 ? void 0 : exp.cardName) === 'proposerDetails';
      })), {}, {
        cardFlag: false,
        subSections: _toConsumableArray((_expandedCard$current20 = expandedCard.current.find(function (exp) {
          return (exp === null || exp === void 0 ? void 0 : exp.cardName) === 'proposerDetails';
        })) === null || _expandedCard$current20 === void 0 ? void 0 : (_expandedCard$current21 = _expandedCard$current20.subSections) === null || _expandedCard$current21 === void 0 ? void 0 : _expandedCard$current21.filter(function (subSection) {
          return subSection !== 'taxIdentificationDetails';
        }))
      })]);

      if (props.forwardedAlertsRef && props.forwardedAlertsRef.current) {
        props.forwardedAlertsRef.current = [];
      }

      setProposerDetailsCardToggle(true);
    },
    grid_data: [{
      type: 'text',
      min: 0,
      className: 'uppercase',
      onKeyDown: function onKeyDown(evt) {
        return evt.key === 'e' && evt.preventDefault();
      },
      label: /*#__PURE__*/React.createElement("div", null, "PAN Card Number", /*#__PURE__*/React.createElement(Text, {
        severity: "error"
      }, "*")),
      labelReadOnly: /*#__PURE__*/React.createElement("div", null, "PAN Card Number ", /*#__PURE__*/React.createElement(Text, {
        severity: "error"
      })),
      name: 'proposerDetails.panNumber',
      disabled: values === null || values === void 0 ? void 0 : values.isCalculatingPremium
    }, {
      type: 'text',
      min: 0,
      className: 'uppercase',
      onKeyDown: function onKeyDown(evt) {
        return evt.key === 'e' && evt.preventDefault();
      },
      label: /*#__PURE__*/React.createElement("div", null, "GST Number ", /*#__PURE__*/React.createElement(Text, {
        severity: "error"
      })),
      labelReadOnly: /*#__PURE__*/React.createElement("div", null, "GST Number ", /*#__PURE__*/React.createElement(Text, {
        severity: "error"
      })),
      name: 'proposerDetails.gstNumber',
      disabled: true
    }].filter(function (d) {
      return d;
    })
  } //   }
  : null, {
    title: /*#__PURE__*/React.createElement(Text, {
      type: "normal",
      className: 'font-semibold'
    }, "Permanent Address"),
    grid_type: 'input',
    clickToEdit: true,
    initDisplayEdit: viewRenewPolicyData !== null && viewRenewPolicyData !== void 0 && viewRenewPolicyData.isProposalRenewed ? false : (_expandedCard$current22 = expandedCard.current.find(function (exp) {
      return (exp === null || exp === void 0 ? void 0 : exp.cardName) === 'proposerDetails';
    })) === null || _expandedCard$current22 === void 0 ? void 0 : (_expandedCard$current23 = _expandedCard$current22.subSections) === null || _expandedCard$current23 === void 0 ? void 0 : _expandedCard$current23.includes('permanentAddress'),
    onValueChanges: function onValueChanges(values) {
      setValueChanges(values);
    },

    /* Added Condition to remove edit button only for TW Renewal*/
    editDisplayDisabled: (viewRenewPolicyData === null || viewRenewPolicyData === void 0 ? void 0 : (_viewRenewPolicyData$ = viewRenewPolicyData.businessType) === null || _viewRenewPolicyData$ === void 0 ? void 0 : (_viewRenewPolicyData$2 = _viewRenewPolicyData$.toLowerCase()) === null || _viewRenewPolicyData$2 === void 0 ? void 0 : _viewRenewPolicyData$2.search('renewal')) !== -1 && (viewRenewPolicyData === null || viewRenewPolicyData === void 0 ? void 0 : viewRenewPolicyData.vehicleTabDetails) !== null ? (props === null || props === void 0 ? void 0 : (_props$productCode = props.productCode) === null || _props$productCode === void 0 ? void 0 : _props$productCode.toString()) === '3191' || (props === null || props === void 0 ? void 0 : (_props$productCode2 = props.productCode) === null || _props$productCode2 === void 0 ? void 0 : _props$productCode2.toString()) === '3192' || (props === null || props === void 0 ? void 0 : (_props$productCode3 = props.productCode) === null || _props$productCode3 === void 0 ? void 0 : _props$productCode3.toString()) === '3152' : // (['Kotak Two Wheeler Long Term','Two Wheeler Protect � OD Only',
    //     'Long Term Two Wheeler Secure - Liability Only']?.find(
    //       (e)=> e === viewRenewPolicyData?.quoteData?.productType )) 
    viewRenewPolicyData === null || viewRenewPolicyData === void 0 ? void 0 : viewRenewPolicyData.isProposalRenewed,
    onEdit: function onEdit(_) {
      var _expandedCard$current24;

      setEnableRenew(false);
      setFieldValue("countEditsOpen", (values === null || values === void 0 ? void 0 : values.countEditsOpen) + 1);
      expandedCard.current = [].concat(_toConsumableArray(expandedCard.current.filter(function (exp) {
        return (exp === null || exp === void 0 ? void 0 : exp.cardName) !== 'proposerDetails';
      })), [_objectSpread2(_objectSpread2({}, expandedCard.current.find(function (exp) {
        return (exp === null || exp === void 0 ? void 0 : exp.cardName) === 'proposerDetails';
      })), {}, {
        cardFlag: true,
        subSections: [].concat(_toConsumableArray((_expandedCard$current24 = expandedCard.current.find(function (exp) {
          return (exp === null || exp === void 0 ? void 0 : exp.cardName) === 'proposerDetails';
        })) === null || _expandedCard$current24 === void 0 ? void 0 : _expandedCard$current24.subSections), ['permanentAddress'])
      })]);

      if (props.forwardedAlertsRef && props.forwardedAlertsRef.current) {
        props.forwardedAlertsRef.current = [];
      }

      updateViewRenewPolicyData({
        isProposalReadyForRenewal: false
      });
      setProposerDetailsCardToggle(false);
    },
    onCancel: function onCancel(_, valuesBeforeEdit) {
      var _valuesBeforeEdit$pro12, _valuesBeforeEdit$pro13, _valuesBeforeEdit$pro14, _valuesBeforeEdit$pro15, _valuesBeforeEdit$pro16, _valuesBeforeEdit$pro17, _valuesBeforeEdit$pro18, _valuesBeforeEdit$pro19, _expandedCard$current25, _expandedCard$current26;

      if ((values === null || values === void 0 ? void 0 : values.countEditsOpen) === 1) {
        updateViewRenewPolicyData({
          isProposalReadyForRenewal: true
        });
        setEnableRenew(true);
      }

      setFieldValue("countEditsOpen", (values === null || values === void 0 ? void 0 : values.countEditsOpen) - 1);
      setFieldValue('proposerDetails.permAddressLine1', valuesBeforeEdit === null || valuesBeforeEdit === void 0 ? void 0 : (_valuesBeforeEdit$pro12 = valuesBeforeEdit.proposerDetails) === null || _valuesBeforeEdit$pro12 === void 0 ? void 0 : _valuesBeforeEdit$pro12.permAddressLine1);
      setFieldValue('proposerDetails.permAddressLine2', valuesBeforeEdit === null || valuesBeforeEdit === void 0 ? void 0 : (_valuesBeforeEdit$pro13 = valuesBeforeEdit.proposerDetails) === null || _valuesBeforeEdit$pro13 === void 0 ? void 0 : _valuesBeforeEdit$pro13.permAddressLine2);
      setFieldValue('proposerDetails.permAddressLine3', valuesBeforeEdit === null || valuesBeforeEdit === void 0 ? void 0 : (_valuesBeforeEdit$pro14 = valuesBeforeEdit.proposerDetails) === null || _valuesBeforeEdit$pro14 === void 0 ? void 0 : _valuesBeforeEdit$pro14.permAddressLine3);
      setFieldValue('proposerDetails.permLandmark', valuesBeforeEdit === null || valuesBeforeEdit === void 0 ? void 0 : (_valuesBeforeEdit$pro15 = valuesBeforeEdit.proposerDetails) === null || _valuesBeforeEdit$pro15 === void 0 ? void 0 : _valuesBeforeEdit$pro15.permLandmark);
      setFieldValue('proposerDetails.permPincode', valuesBeforeEdit === null || valuesBeforeEdit === void 0 ? void 0 : (_valuesBeforeEdit$pro16 = valuesBeforeEdit.proposerDetails) === null || _valuesBeforeEdit$pro16 === void 0 ? void 0 : _valuesBeforeEdit$pro16.permPincode);
      setFieldValue('proposerDetails.permCityTownVillage', valuesBeforeEdit === null || valuesBeforeEdit === void 0 ? void 0 : (_valuesBeforeEdit$pro17 = valuesBeforeEdit.proposerDetails) === null || _valuesBeforeEdit$pro17 === void 0 ? void 0 : _valuesBeforeEdit$pro17.permCityTownVillage);
      setFieldValue('proposerDetails.permDistrict', valuesBeforeEdit === null || valuesBeforeEdit === void 0 ? void 0 : (_valuesBeforeEdit$pro18 = valuesBeforeEdit.proposerDetails) === null || _valuesBeforeEdit$pro18 === void 0 ? void 0 : _valuesBeforeEdit$pro18.permDistrict);
      setFieldValue('proposerDetails.permState', valuesBeforeEdit === null || valuesBeforeEdit === void 0 ? void 0 : (_valuesBeforeEdit$pro19 = valuesBeforeEdit.proposerDetails) === null || _valuesBeforeEdit$pro19 === void 0 ? void 0 : _valuesBeforeEdit$pro19.permState);
      expandedCard.current = [].concat(_toConsumableArray(expandedCard.current.filter(function (exp) {
        return (exp === null || exp === void 0 ? void 0 : exp.cardName) !== 'proposerDetails';
      })), [_objectSpread2(_objectSpread2({}, expandedCard.current.find(function (exp) {
        return (exp === null || exp === void 0 ? void 0 : exp.cardName) === 'proposerDetails';
      })), {}, {
        cardFlag: false,
        subSections: _toConsumableArray((_expandedCard$current25 = expandedCard.current.find(function (exp) {
          return (exp === null || exp === void 0 ? void 0 : exp.cardName) === 'proposerDetails';
        })) === null || _expandedCard$current25 === void 0 ? void 0 : (_expandedCard$current26 = _expandedCard$current25.subSections) === null || _expandedCard$current26 === void 0 ? void 0 : _expandedCard$current26.filter(function (subSection) {
          return subSection !== 'permanentAddress';
        }))
      })]);

      if (props.forwardedAlertsRef && props.forwardedAlertsRef.current) {
        props.forwardedAlertsRef.current = [];
      }

      setProposerDetailsCardToggle(true);
    },
    onSave: function onSave(_) {
      var _expandedCard$current27, _expandedCard$current28;

      if ((values === null || values === void 0 ? void 0 : values.countEditsOpen) === 1) {
        updateViewRenewPolicyData({
          isProposalReadyForRenewal: true
        });
        setEnableRenew(true);
      }

      setFieldValue("countEditsOpen", (values === null || values === void 0 ? void 0 : values.countEditsOpen) - 1);
      expandedCard.current = [].concat(_toConsumableArray(expandedCard.current.filter(function (exp) {
        return (exp === null || exp === void 0 ? void 0 : exp.cardName) !== 'proposerDetails';
      })), [_objectSpread2(_objectSpread2({}, expandedCard.current.find(function (exp) {
        return (exp === null || exp === void 0 ? void 0 : exp.cardName) === 'proposerDetails';
      })), {}, {
        cardFlag: false,
        subSections: _toConsumableArray((_expandedCard$current27 = expandedCard.current.find(function (exp) {
          return (exp === null || exp === void 0 ? void 0 : exp.cardName) === 'proposerDetails';
        })) === null || _expandedCard$current27 === void 0 ? void 0 : (_expandedCard$current28 = _expandedCard$current27.subSections) === null || _expandedCard$current28 === void 0 ? void 0 : _expandedCard$current28.filter(function (subSection) {
          return subSection !== 'permanentAddress';
        }))
      })]);

      if (props.forwardedAlertsRef && props.forwardedAlertsRef.current) {
        props.forwardedAlertsRef.current = [];
      }

      setProposerDetailsCardToggle(true);
    },
    disableSubmit: (values === null || values === void 0 ? void 0 : values.isCalculatingPremium) || loadingPermCustAddr || ((_validate5 = validate(values)) === null || _validate5 === void 0 ? void 0 : (_validate5$proposerDe = _validate5.proposerDetails) === null || _validate5$proposerDe === void 0 ? void 0 : _validate5$proposerDe.permAddressLine1) !== undefined || ((_validate6 = validate(values)) === null || _validate6 === void 0 ? void 0 : (_validate6$proposerDe = _validate6.proposerDetails) === null || _validate6$proposerDe === void 0 ? void 0 : _validate6$proposerDe.permAddressLine2) !== undefined || ((_validate7 = validate(values)) === null || _validate7 === void 0 ? void 0 : (_validate7$proposerDe = _validate7.proposerDetails) === null || _validate7$proposerDe === void 0 ? void 0 : _validate7$proposerDe.permPincode) !== undefined || ((_validate8 = validate(values)) === null || _validate8 === void 0 ? void 0 : (_validate8$proposerDe = _validate8.proposerDetails) === null || _validate8$proposerDe === void 0 ? void 0 : _validate8$proposerDe.permState) !== undefined || ((_validate9 = validate(values)) === null || _validate9 === void 0 ? void 0 : (_validate9$proposerDe = _validate9.proposerDetails) === null || _validate9$proposerDe === void 0 ? void 0 : _validate9$proposerDe.permDistrict) !== undefined || ((_validate10 = validate(values)) === null || _validate10 === void 0 ? void 0 : (_validate10$proposerD = _validate10.proposerDetails) === null || _validate10$proposerD === void 0 ? void 0 : _validate10$proposerD.permCityTownVillage) !== undefined,
    disableCancel: values === null || values === void 0 ? void 0 : values.isCalculatingPremium,
    disableEdit: values === null || values === void 0 ? void 0 : values.isCalculatingPremium,
    resetOnCancel: false,
    isBorderRequired: true,
    borderClassName: 'border-t-2 border-neutral pt-2',
    grid_data_on_edit: [{
      type: 'text',
      label: /*#__PURE__*/React.createElement("div", null, "Address Line 1 ", /*#__PURE__*/React.createElement(Text, {
        severity: "error"
      }, "*")),
      labelReadOnly: /*#__PURE__*/React.createElement("div", null, "Address Line 1 ", /*#__PURE__*/React.createElement(Text, null)),
      name: 'proposerDetails.permAddressLine1',
      disabled: values === null || values === void 0 ? void 0 : values.isCalculatingPremium,
      onDataChange: function onDataChange(val, setFieldValue) {
        var _values$proposerDetai;

        if (values !== null && values !== void 0 && (_values$proposerDetai = values.proposerDetails) !== null && _values$proposerDetai !== void 0 && _values$proposerDetai.permCommAddressYN) {
          setFieldValue('proposerDetails.commAddressLine1', val);
        }
      }
    }, {
      type: 'text',
      label: /*#__PURE__*/React.createElement("div", null, "Address Line 2 ", /*#__PURE__*/React.createElement(Text, {
        severity: "error"
      })),
      disabled: values === null || values === void 0 ? void 0 : values.isCalculatingPremium,
      labelReadOnly: /*#__PURE__*/React.createElement("div", null, "Address Line 2 ", /*#__PURE__*/React.createElement(Text, null)),
      name: 'proposerDetails.permAddressLine2',
      onDataChange: function onDataChange(val, setFieldValue) {
        if (values.proposerDetails.permCommAddressYN) {
          setFieldValue('proposerDetails.commAddressLine2', val);
        }
      }
    }, {
      type: 'text',
      label: /*#__PURE__*/React.createElement("div", null, "Address Line 3 ", /*#__PURE__*/React.createElement(Text, null)),
      disabled: values === null || values === void 0 ? void 0 : values.isCalculatingPremium,
      name: 'proposerDetails.permAddressLine3',
      onDataChange: function onDataChange(val, setFieldValue) {
        var _values$proposerDetai2;

        if (values !== null && values !== void 0 && (_values$proposerDetai2 = values.proposerDetails) !== null && _values$proposerDetai2 !== void 0 && _values$proposerDetai2.permCommAddressYN) {
          setFieldValue('proposerDetails.commAddressLine3', val);
        }
      }
    }, {
      type: 'text',
      label: /*#__PURE__*/React.createElement("div", null, "Landmark ", /*#__PURE__*/React.createElement(Text, null)),
      name: 'proposerDetails.permLandmark',
      disabled: values === null || values === void 0 ? void 0 : values.isCalculatingPremium,
      onDataChange: function onDataChange(val, setFieldValue) {
        var _values$proposerDetai3;

        if (values !== null && values !== void 0 && (_values$proposerDetai3 = values.proposerDetails) !== null && _values$proposerDetai3 !== void 0 && _values$proposerDetai3.permCommAddressYN) {
          setFieldValue('proposerDetails.commLandmark', val);
        }
      }
    }, {
      type: 'input-lookup',
      size: 'large',
      onLookup: onPermAddrLookup,
      disabled: loadingPermCustAddr || (values === null || values === void 0 ? void 0 : values.isCalculatingPremium),
      loading: loadingPermCustAddr,
      label: /*#__PURE__*/React.createElement("div", null, "Pin Code ", /*#__PURE__*/React.createElement(Text, {
        severity: "error"
      }, "*")),
      labelReadOnly: /*#__PURE__*/React.createElement("div", null, "Pin Code ", /*#__PURE__*/React.createElement(Text, null)),
      name: 'proposerDetails.permPincode',
      onDataChange: function onDataChange(val, setFieldValue) {
        var _values$proposerDetai4;

        setFieldValue('proposerDetails.permCityTownVillage', '');
        setFieldValue('proposerDetails.permState', '');
        setFieldValue('proposerDetails.permDistrict', '');

        if (values !== null && values !== void 0 && (_values$proposerDetai4 = values.proposerDetails) !== null && _values$proposerDetai4 !== void 0 && _values$proposerDetai4.permCommAddressYN) {
          setFieldValue('proposerDetails.commPincode', val);
          setFieldValue('proposerDetails.commCityTownVillage', '');
          setFieldValue('proposerDetails.commState', '');
          setFieldValue('proposerDetails.commDistrict', '');
        }
      }
    }, {
      type: 'text',
      label: /*#__PURE__*/React.createElement("div", null, "City/Town/Village ", /*#__PURE__*/React.createElement(Text, {
        severity: "error"
      }, "*")),
      labelReadOnly: /*#__PURE__*/React.createElement("div", null, "City/Town/Village ", /*#__PURE__*/React.createElement(Text, null)),
      name: 'proposerDetails.permCityTownVillage',
      disabled: true
    }, {
      type: 'text',
      label: /*#__PURE__*/React.createElement("div", null, "District ", /*#__PURE__*/React.createElement(Text, {
        severity: "error"
      }, "*")),
      labelReadOnly: /*#__PURE__*/React.createElement("div", null, "District ", /*#__PURE__*/React.createElement(Text, null)),
      name: 'proposerDetails.permDistrict',
      disabled: true
    }, {
      type: 'text',
      label: /*#__PURE__*/React.createElement("div", null, "State ", /*#__PURE__*/React.createElement(Text, {
        severity: "error"
      }, "*")),
      labelReadOnly: /*#__PURE__*/React.createElement("div", null, "State ", /*#__PURE__*/React.createElement(Text, null)),
      name: 'proposerDetails.permState',
      disabled: true
    }],
    grid_data: [{
      type: 'render',
      colSpan: repeatFormsReadOnly,
      component: function component() {
        var _values$proposerDetai5, _values$proposerDetai6, _values$proposerDetai7, _values$proposerDetai8, _values$proposerDetai9, _values$proposerDetai10, _values$proposerDetai11, _values$proposerDetai12, _values$proposerDetai13, _values$proposerDetai14, _values$proposerDetai15, _values$proposerDetai16, _values$proposerDetai17, _values$proposerDetai18, _values$proposerDetai19;

        return /*#__PURE__*/React.createElement("div", {
          className: "flex flex-col space-y-4"
        }, /*#__PURE__*/React.createElement(Text, {
          type: "normal",
          className: "break-words"
        }, [values === null || values === void 0 ? void 0 : (_values$proposerDetai5 = values.proposerDetails) === null || _values$proposerDetai5 === void 0 ? void 0 : (_values$proposerDetai6 = _values$proposerDetai5.permAddressLine1) === null || _values$proposerDetai6 === void 0 ? void 0 : _values$proposerDetai6.trim(), values === null || values === void 0 ? void 0 : (_values$proposerDetai7 = values.proposerDetails) === null || _values$proposerDetai7 === void 0 ? void 0 : (_values$proposerDetai8 = _values$proposerDetai7.permAddressLine2) === null || _values$proposerDetai8 === void 0 ? void 0 : _values$proposerDetai8.trim(), values === null || values === void 0 ? void 0 : (_values$proposerDetai9 = values.proposerDetails) === null || _values$proposerDetai9 === void 0 ? void 0 : (_values$proposerDetai10 = _values$proposerDetai9.permAddressLine3) === null || _values$proposerDetai10 === void 0 ? void 0 : _values$proposerDetai10.trim(), values === null || values === void 0 ? void 0 : (_values$proposerDetai11 = values.proposerDetails) === null || _values$proposerDetai11 === void 0 ? void 0 : (_values$proposerDetai12 = _values$proposerDetai11.permLandmark) === null || _values$proposerDetai12 === void 0 ? void 0 : _values$proposerDetai12.trim(), values === null || values === void 0 ? void 0 : (_values$proposerDetai13 = values.proposerDetails) === null || _values$proposerDetai13 === void 0 ? void 0 : (_values$proposerDetai14 = _values$proposerDetai13.permCityTownVillage) === null || _values$proposerDetai14 === void 0 ? void 0 : _values$proposerDetai14.trim(), values === null || values === void 0 ? void 0 : (_values$proposerDetai15 = values.proposerDetails) === null || _values$proposerDetai15 === void 0 ? void 0 : (_values$proposerDetai16 = _values$proposerDetai15.permDistrict) === null || _values$proposerDetai16 === void 0 ? void 0 : _values$proposerDetai16.trim(), values === null || values === void 0 ? void 0 : (_values$proposerDetai17 = values.proposerDetails) === null || _values$proposerDetai17 === void 0 ? void 0 : (_values$proposerDetai18 = _values$proposerDetai17.permState) === null || _values$proposerDetai18 === void 0 ? void 0 : _values$proposerDetai18.trim(), values === null || values === void 0 ? void 0 : (_values$proposerDetai19 = values.proposerDetails) === null || _values$proposerDetai19 === void 0 ? void 0 : _values$proposerDetai19.permPincode].filter(function (a) {
          return a;
        }).join(',')));
      }
    }].filter(function (d) {
      return d;
    })
  }, {
    title: /*#__PURE__*/React.createElement(Text, {
      type: "normal",
      className: 'font-semibold'
    }, "Communication Address"),
    grid_type: 'input',
    clickToEdit: true,
    initDisplayEdit: viewRenewPolicyData !== null && viewRenewPolicyData !== void 0 && viewRenewPolicyData.isProposalRenewed ? false : (_expandedCard$current29 = expandedCard.current.find(function (exp) {
      return (exp === null || exp === void 0 ? void 0 : exp.cardName) === 'proposerDetails';
    })) === null || _expandedCard$current29 === void 0 ? void 0 : (_expandedCard$current30 = _expandedCard$current29.subSections) === null || _expandedCard$current30 === void 0 ? void 0 : _expandedCard$current30.includes('communicationAddress'),
    onValueChanges: function onValueChanges(values) {
      setValueChanges(values);
    },

    /* Added Condition to remove edit button only for TW Renewal*/
    editDisplayDisabled: (viewRenewPolicyData === null || viewRenewPolicyData === void 0 ? void 0 : (_viewRenewPolicyData$3 = viewRenewPolicyData.businessType) === null || _viewRenewPolicyData$3 === void 0 ? void 0 : (_viewRenewPolicyData$4 = _viewRenewPolicyData$3.toLowerCase()) === null || _viewRenewPolicyData$4 === void 0 ? void 0 : _viewRenewPolicyData$4.search('renewal')) !== -1 && (viewRenewPolicyData === null || viewRenewPolicyData === void 0 ? void 0 : viewRenewPolicyData.vehicleTabDetails) !== null ? (props === null || props === void 0 ? void 0 : (_props$productCode4 = props.productCode) === null || _props$productCode4 === void 0 ? void 0 : _props$productCode4.toString()) === '3191' || (props === null || props === void 0 ? void 0 : (_props$productCode5 = props.productCode) === null || _props$productCode5 === void 0 ? void 0 : _props$productCode5.toString()) === '3192' || (props === null || props === void 0 ? void 0 : (_props$productCode6 = props.productCode) === null || _props$productCode6 === void 0 ? void 0 : _props$productCode6.toString()) === '3152' : // (['Kotak Two Wheeler Long Term','Two Wheeler Protect � OD Only',
    //     'Long Term Two Wheeler Secure - Liability Only']?.find(
    //       (e)=> e === viewRenewPolicyData?.quoteData?.productType )) 
    viewRenewPolicyData === null || viewRenewPolicyData === void 0 ? void 0 : viewRenewPolicyData.isProposalRenewed,
    onEdit: function onEdit(_) {
      var _expandedCard$current31;

      setEnableRenew(false);
      setFieldValue("countEditsOpen", (values === null || values === void 0 ? void 0 : values.countEditsOpen) + 1);
      expandedCard.current = [].concat(_toConsumableArray(expandedCard.current.filter(function (exp) {
        return (exp === null || exp === void 0 ? void 0 : exp.cardName) !== 'proposerDetails';
      })), [_objectSpread2(_objectSpread2({}, expandedCard.current.find(function (exp) {
        return (exp === null || exp === void 0 ? void 0 : exp.cardName) === 'proposerDetails';
      })), {}, {
        cardFlag: true,
        subSections: [].concat(_toConsumableArray((_expandedCard$current31 = expandedCard.current.find(function (exp) {
          return (exp === null || exp === void 0 ? void 0 : exp.cardName) === 'proposerDetails';
        })) === null || _expandedCard$current31 === void 0 ? void 0 : _expandedCard$current31.subSections), ['communicationAddress'])
      })]);

      if (props.forwardedAlertsRef && props.forwardedAlertsRef.current) {
        props.forwardedAlertsRef.current = [];
      }

      updateViewRenewPolicyData({
        isProposalReadyForRenewal: false
      });
      setProposerDetailsCardToggle(false);
    },
    onCancel: function onCancel(_, valuesBeforeEdit) {
      var _valuesBeforeEdit$pro20, _valuesBeforeEdit$pro21, _valuesBeforeEdit$pro22, _valuesBeforeEdit$pro23, _valuesBeforeEdit$pro24, _valuesBeforeEdit$pro25, _valuesBeforeEdit$pro26, _valuesBeforeEdit$pro27, _valuesBeforeEdit$pro28, _expandedCard$current32, _expandedCard$current33;

      if ((values === null || values === void 0 ? void 0 : values.countEditsOpen) === 1) {
        updateViewRenewPolicyData({
          isProposalReadyForRenewal: true
        });
        setEnableRenew(true);
      }

      setFieldValue("countEditsOpen", (values === null || values === void 0 ? void 0 : values.countEditsOpen) - 1);
      setFieldValue('proposerDetails.permCommAddressYN', valuesBeforeEdit === null || valuesBeforeEdit === void 0 ? void 0 : (_valuesBeforeEdit$pro20 = valuesBeforeEdit.proposerDetails) === null || _valuesBeforeEdit$pro20 === void 0 ? void 0 : _valuesBeforeEdit$pro20.permCommAddressYN);
      setFieldValue('proposerDetails.commAddressLine1', valuesBeforeEdit === null || valuesBeforeEdit === void 0 ? void 0 : (_valuesBeforeEdit$pro21 = valuesBeforeEdit.proposerDetails) === null || _valuesBeforeEdit$pro21 === void 0 ? void 0 : _valuesBeforeEdit$pro21.commAddressLine1);
      setFieldValue('proposerDetails.commAddressLine2', valuesBeforeEdit === null || valuesBeforeEdit === void 0 ? void 0 : (_valuesBeforeEdit$pro22 = valuesBeforeEdit.proposerDetails) === null || _valuesBeforeEdit$pro22 === void 0 ? void 0 : _valuesBeforeEdit$pro22.commAddressLine2);
      setFieldValue('proposerDetails.commAddressLine3', valuesBeforeEdit === null || valuesBeforeEdit === void 0 ? void 0 : (_valuesBeforeEdit$pro23 = valuesBeforeEdit.proposerDetails) === null || _valuesBeforeEdit$pro23 === void 0 ? void 0 : _valuesBeforeEdit$pro23.commAddressLine3);
      setFieldValue('proposerDetails.commLandmark', valuesBeforeEdit === null || valuesBeforeEdit === void 0 ? void 0 : (_valuesBeforeEdit$pro24 = valuesBeforeEdit.proposerDetails) === null || _valuesBeforeEdit$pro24 === void 0 ? void 0 : _valuesBeforeEdit$pro24.commLandmark);
      setFieldValue('proposerDetails.commPincode', valuesBeforeEdit === null || valuesBeforeEdit === void 0 ? void 0 : (_valuesBeforeEdit$pro25 = valuesBeforeEdit.proposerDetails) === null || _valuesBeforeEdit$pro25 === void 0 ? void 0 : _valuesBeforeEdit$pro25.commPincode);
      setFieldValue('proposerDetails.commCityTownVillage', valuesBeforeEdit === null || valuesBeforeEdit === void 0 ? void 0 : (_valuesBeforeEdit$pro26 = valuesBeforeEdit.proposerDetails) === null || _valuesBeforeEdit$pro26 === void 0 ? void 0 : _valuesBeforeEdit$pro26.commCityTownVillage);
      setFieldValue('proposerDetails.commDistrict', valuesBeforeEdit === null || valuesBeforeEdit === void 0 ? void 0 : (_valuesBeforeEdit$pro27 = valuesBeforeEdit.proposerDetails) === null || _valuesBeforeEdit$pro27 === void 0 ? void 0 : _valuesBeforeEdit$pro27.commDistrict);
      setFieldValue('proposerDetails.commState', valuesBeforeEdit === null || valuesBeforeEdit === void 0 ? void 0 : (_valuesBeforeEdit$pro28 = valuesBeforeEdit.proposerDetails) === null || _valuesBeforeEdit$pro28 === void 0 ? void 0 : _valuesBeforeEdit$pro28.commState);
      expandedCard.current = [].concat(_toConsumableArray(expandedCard.current.filter(function (exp) {
        return (exp === null || exp === void 0 ? void 0 : exp.cardName) !== 'proposerDetails';
      })), [_objectSpread2(_objectSpread2({}, expandedCard.current.find(function (exp) {
        return (exp === null || exp === void 0 ? void 0 : exp.cardName) === 'proposerDetails';
      })), {}, {
        cardFlag: false,
        subSections: _toConsumableArray((_expandedCard$current32 = expandedCard.current.find(function (exp) {
          return (exp === null || exp === void 0 ? void 0 : exp.cardName) === 'proposerDetails';
        })) === null || _expandedCard$current32 === void 0 ? void 0 : (_expandedCard$current33 = _expandedCard$current32.subSections) === null || _expandedCard$current33 === void 0 ? void 0 : _expandedCard$current33.filter(function (subSection) {
          return subSection !== 'communicationAddress';
        }))
      })]);

      if (props.forwardedAlertsRef && props.forwardedAlertsRef.current) {
        props.forwardedAlertsRef.current = [];
      }

      setProposerDetailsCardToggle(true);
    },
    onSave: function onSave(_) {
      var _expandedCard$current34, _expandedCard$current35;

      if ((values === null || values === void 0 ? void 0 : values.countEditsOpen) === 1) {
        updateViewRenewPolicyData({
          isProposalReadyForRenewal: true
        });
        setEnableRenew(true);
      }

      setFieldValue("countEditsOpen", (values === null || values === void 0 ? void 0 : values.countEditsOpen) - 1);
      expandedCard.current = [].concat(_toConsumableArray(expandedCard.current.filter(function (exp) {
        return (exp === null || exp === void 0 ? void 0 : exp.cardName) !== 'proposerDetails';
      })), [_objectSpread2(_objectSpread2({}, expandedCard.current.find(function (exp) {
        return (exp === null || exp === void 0 ? void 0 : exp.cardName) === 'proposerDetails';
      })), {}, {
        cardFlag: false,
        subSections: _toConsumableArray((_expandedCard$current34 = expandedCard.current.find(function (exp) {
          return (exp === null || exp === void 0 ? void 0 : exp.cardName) === 'proposerDetails';
        })) === null || _expandedCard$current34 === void 0 ? void 0 : (_expandedCard$current35 = _expandedCard$current34.subSections) === null || _expandedCard$current35 === void 0 ? void 0 : _expandedCard$current35.filter(function (subSection) {
          return subSection !== 'communicationAddress';
        }))
      })]);

      if (props.forwardedAlertsRef && props.forwardedAlertsRef.current) {
        props.forwardedAlertsRef.current = [];
      }

      setProposerDetailsCardToggle(true);
    },
    disableSubmit: (values === null || values === void 0 ? void 0 : values.isCalculatingPremium) || loadingCommCustAddr || ((_validate11 = validate(values)) === null || _validate11 === void 0 ? void 0 : (_validate11$proposerD = _validate11.proposerDetails) === null || _validate11$proposerD === void 0 ? void 0 : _validate11$proposerD.commAddressLine1) !== undefined || ((_validate12 = validate(values)) === null || _validate12 === void 0 ? void 0 : (_validate12$proposerD = _validate12.proposerDetails) === null || _validate12$proposerD === void 0 ? void 0 : _validate12$proposerD.commAddressLine2) !== undefined || ((_validate13 = validate(values)) === null || _validate13 === void 0 ? void 0 : (_validate13$proposerD = _validate13.proposerDetails) === null || _validate13$proposerD === void 0 ? void 0 : _validate13$proposerD.commPincode) !== undefined || ((_validate14 = validate(values)) === null || _validate14 === void 0 ? void 0 : (_validate14$proposerD = _validate14.proposerDetails) === null || _validate14$proposerD === void 0 ? void 0 : _validate14$proposerD.commState) !== undefined || ((_validate15 = validate(values)) === null || _validate15 === void 0 ? void 0 : (_validate15$proposerD = _validate15.proposerDetails) === null || _validate15$proposerD === void 0 ? void 0 : _validate15$proposerD.commDistrict) !== undefined || ((_validate16 = validate(values)) === null || _validate16 === void 0 ? void 0 : (_validate16$proposerD = _validate16.proposerDetails) === null || _validate16$proposerD === void 0 ? void 0 : _validate16$proposerD.commCityTownVillage) !== undefined,
    disableEdit: values === null || values === void 0 ? void 0 : values.isCalculatingPremium,
    disableCancel: values === null || values === void 0 ? void 0 : values.isCalculatingPremium,
    resetOnCancel: false,
    isBorderRequired: true,
    borderClassName: 'border-t-2 border-neutral pt-2',
    grid_data_on_edit: [{
      type: 'checkbox',
      name: 'proposerDetails.permCommAddressYN',
      disabled: loadingPermCustAddr || loadingCommCustAddr || (values === null || values === void 0 ? void 0 : values.isCalculatingPremium),
      label: 'Communication address same as permanent address',
      colSpan: repeat,
      onDataChange: function onDataChange(val, setFieldValue) {
        if (val) {
          var _values$proposerDetai20, _values$proposerDetai21, _values$proposerDetai22, _values$proposerDetai23, _values$proposerDetai24, _values$proposerDetai25, _values$proposerDetai26;

          setFieldValue('proposerDetails.commAddressLine1', values === null || values === void 0 ? void 0 : (_values$proposerDetai20 = values.proposerDetails) === null || _values$proposerDetai20 === void 0 ? void 0 : _values$proposerDetai20.permAddressLine1);
          setFieldValue('proposerDetails.commAddressLine2', values.proposerDetails.permAddressLine2);
          setFieldValue('proposerDetails.commAddressLine3', values === null || values === void 0 ? void 0 : (_values$proposerDetai21 = values.proposerDetails) === null || _values$proposerDetai21 === void 0 ? void 0 : _values$proposerDetai21.permAddressLine3);
          setFieldValue('proposerDetails.commLandmark', values === null || values === void 0 ? void 0 : (_values$proposerDetai22 = values.proposerDetails) === null || _values$proposerDetai22 === void 0 ? void 0 : _values$proposerDetai22.permLandmark);
          setFieldValue('proposerDetails.commPincode', values === null || values === void 0 ? void 0 : (_values$proposerDetai23 = values.proposerDetails) === null || _values$proposerDetai23 === void 0 ? void 0 : _values$proposerDetai23.permPincode);
          setFieldValue('proposerDetails.commCityTownVillage', values === null || values === void 0 ? void 0 : (_values$proposerDetai24 = values.proposerDetails) === null || _values$proposerDetai24 === void 0 ? void 0 : _values$proposerDetai24.permCityTownVillage);
          setFieldValue('proposerDetails.commDistrict', values === null || values === void 0 ? void 0 : (_values$proposerDetai25 = values.proposerDetails) === null || _values$proposerDetai25 === void 0 ? void 0 : _values$proposerDetai25.permDistrict);
          setFieldValue('proposerDetails.commState', values === null || values === void 0 ? void 0 : (_values$proposerDetai26 = values.proposerDetails) === null || _values$proposerDetai26 === void 0 ? void 0 : _values$proposerDetai26.permState);
        } else {
          setFieldValue('proposerDetails.commAddressLine1', '');
          setFieldValue('proposerDetails.commAddressLine2', '');
          setFieldValue('proposerDetails.commAddressLine3', '');
          setFieldValue('proposerDetails.commLandmark', '');
          setFieldValue('proposerDetails.commPincode', '');
          setFieldValue('proposerDetails.commCityTownVillage', '');
          setFieldValue('proposerDetails.commDistrict', '');
          setFieldValue('proposerDetails.commState', '');
        }
      }
    }, !(values !== null && values !== void 0 && (_values$proposerDetai27 = values.proposerDetails) !== null && _values$proposerDetai27 !== void 0 && _values$proposerDetai27.permCommAddressYN) ? {
      type: 'text',
      label: /*#__PURE__*/React.createElement("div", null, "Address Line 1 ", /*#__PURE__*/React.createElement(Text, {
        severity: "error"
      }, "*")),
      labelReadOnly: /*#__PURE__*/React.createElement("div", null, "Address Line 1 ", /*#__PURE__*/React.createElement(Text, null)),
      name: 'proposerDetails.commAddressLine1',
      disabled: values === null || values === void 0 ? void 0 : values.isCalculatingPremium
    } : null, !(values !== null && values !== void 0 && (_values$proposerDetai28 = values.proposerDetails) !== null && _values$proposerDetai28 !== void 0 && _values$proposerDetai28.permCommAddressYN) ? {
      type: 'text',
      label: /*#__PURE__*/React.createElement("div", null, "Address Line 2 ", /*#__PURE__*/React.createElement(Text, {
        severity: "error"
      })),
      labelReadOnly: /*#__PURE__*/React.createElement("div", null, "Address Line 2 ", /*#__PURE__*/React.createElement(Text, null)),
      name: 'proposerDetails.commAddressLine2',
      disabled: values === null || values === void 0 ? void 0 : values.isCalculatingPremium
    } : null, !(values !== null && values !== void 0 && (_values$proposerDetai29 = values.proposerDetails) !== null && _values$proposerDetai29 !== void 0 && _values$proposerDetai29.permCommAddressYN) ? {
      type: 'text',
      label: /*#__PURE__*/React.createElement("div", null, "Address Line 3 ", /*#__PURE__*/React.createElement(Text, null)),
      name: 'proposerDetails.commAddressLine3',
      disabled: values === null || values === void 0 ? void 0 : values.isCalculatingPremium
    } : null, !(values !== null && values !== void 0 && (_values$proposerDetai30 = values.proposerDetails) !== null && _values$proposerDetai30 !== void 0 && _values$proposerDetai30.permCommAddressYN) ? {
      type: 'text',
      label: /*#__PURE__*/React.createElement("div", null, "Landmark ", /*#__PURE__*/React.createElement(Text, null)),
      name: 'proposerDetails.commLandmark',
      disabled: values === null || values === void 0 ? void 0 : values.isCalculatingPremium
    } : null, !(values !== null && values !== void 0 && (_values$proposerDetai31 = values.proposerDetails) !== null && _values$proposerDetai31 !== void 0 && _values$proposerDetai31.permCommAddressYN) ? {
      type: 'input-lookup',
      size: 'large',
      onLookup: onCommAddrLookup,
      disabled: loadingCommCustAddr || (values === null || values === void 0 ? void 0 : values.isCalculatingPremium),
      loading: loadingCommCustAddr,
      label: /*#__PURE__*/React.createElement("div", null, "Pin Code ", /*#__PURE__*/React.createElement(Text, {
        severity: "error"
      }, "*")),
      labelReadOnly: /*#__PURE__*/React.createElement("div", null, "Pin Code ", /*#__PURE__*/React.createElement(Text, null)),
      name: 'proposerDetails.commPincode',
      onDataChange: function onDataChange(val, setFieldValue) {
        setFieldValue('proposerDetails.commCityTownVillage', '');
        setFieldValue('proposerDetails.commState', '');
        setFieldValue('proposerDetails.commDistrict', '');
      }
    } : null, !(values !== null && values !== void 0 && (_values$proposerDetai32 = values.proposerDetails) !== null && _values$proposerDetai32 !== void 0 && _values$proposerDetai32.permCommAddressYN) ? {
      type: 'text',
      label: /*#__PURE__*/React.createElement("div", null, "City/Town/Village", ' ', /*#__PURE__*/React.createElement(Text, {
        severity: "error"
      }, "*")),
      labelReadOnly: /*#__PURE__*/React.createElement("div", null, "City/Town/Village ", /*#__PURE__*/React.createElement(Text, null)),
      name: 'proposerDetails.commCityTownVillage',
      disabled: true
    } : null, !(values !== null && values !== void 0 && (_values$proposerDetai33 = values.proposerDetails) !== null && _values$proposerDetai33 !== void 0 && _values$proposerDetai33.permCommAddressYN) ? {
      type: 'text',
      label: /*#__PURE__*/React.createElement("div", null, "District ", /*#__PURE__*/React.createElement(Text, {
        severity: "error"
      }, "*")),
      labelReadOnly: /*#__PURE__*/React.createElement("div", null, "District ", /*#__PURE__*/React.createElement(Text, null)),
      name: 'proposerDetails.commDistrict',
      disabled: true
    } : null, !(values !== null && values !== void 0 && (_values$proposerDetai34 = values.proposerDetails) !== null && _values$proposerDetai34 !== void 0 && _values$proposerDetai34.permCommAddressYN) ? {
      type: 'text',
      label: /*#__PURE__*/React.createElement("div", null, "State ", /*#__PURE__*/React.createElement(Text, {
        severity: "error"
      }, "*")),
      labelReadOnly: /*#__PURE__*/React.createElement("div", null, "State ", /*#__PURE__*/React.createElement(Text, null)),
      name: 'proposerDetails.commState',
      disabled: true
    } : null].filter(function (d) {
      return d;
    }),
    grid_data: [{
      type: 'render',
      colSpan: repeatFormsReadOnly,
      component: function component() {
        var _values$proposerDetai35, _values$proposerDetai36, _values$proposerDetai37, _values$proposerDetai38, _values$proposerDetai39, _values$proposerDetai40, _values$proposerDetai41, _values$proposerDetai42, _values$proposerDetai43, _values$proposerDetai44, _values$proposerDetai45, _values$proposerDetai46, _values$proposerDetai47, _values$proposerDetai48, _values$proposerDetai49, _values$proposerDetai50;

        return values !== null && values !== void 0 && (_values$proposerDetai35 = values.proposerDetails) !== null && _values$proposerDetai35 !== void 0 && _values$proposerDetai35.permCommAddressYN ? /*#__PURE__*/React.createElement(Text, {
          type: "normal",
          className: "flex gap-2"
        }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
          icon: faInfoCircle,
          className: "text-primary"
        })), /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Text, null, "Communication Address is same as Permanent Address"))) : /*#__PURE__*/React.createElement(Text, {
          type: "normal",
          className: "break-words"
        }, [values === null || values === void 0 ? void 0 : (_values$proposerDetai36 = values.proposerDetails) === null || _values$proposerDetai36 === void 0 ? void 0 : (_values$proposerDetai37 = _values$proposerDetai36.commAddressLine1) === null || _values$proposerDetai37 === void 0 ? void 0 : _values$proposerDetai37.trim(), values === null || values === void 0 ? void 0 : (_values$proposerDetai38 = values.proposerDetails) === null || _values$proposerDetai38 === void 0 ? void 0 : (_values$proposerDetai39 = _values$proposerDetai38.commAddressLine2) === null || _values$proposerDetai39 === void 0 ? void 0 : _values$proposerDetai39.trim(), values === null || values === void 0 ? void 0 : (_values$proposerDetai40 = values.proposerDetails) === null || _values$proposerDetai40 === void 0 ? void 0 : (_values$proposerDetai41 = _values$proposerDetai40.commAddressLine3) === null || _values$proposerDetai41 === void 0 ? void 0 : _values$proposerDetai41.trim(), values === null || values === void 0 ? void 0 : (_values$proposerDetai42 = values.proposerDetails) === null || _values$proposerDetai42 === void 0 ? void 0 : (_values$proposerDetai43 = _values$proposerDetai42.commLandmark) === null || _values$proposerDetai43 === void 0 ? void 0 : _values$proposerDetai43.trim(), values === null || values === void 0 ? void 0 : (_values$proposerDetai44 = values.proposerDetails) === null || _values$proposerDetai44 === void 0 ? void 0 : (_values$proposerDetai45 = _values$proposerDetai44.commCityTownVillage) === null || _values$proposerDetai45 === void 0 ? void 0 : _values$proposerDetai45.trim(), values === null || values === void 0 ? void 0 : (_values$proposerDetai46 = values.proposerDetails) === null || _values$proposerDetai46 === void 0 ? void 0 : (_values$proposerDetai47 = _values$proposerDetai46.commDistrict) === null || _values$proposerDetai47 === void 0 ? void 0 : _values$proposerDetai47.trim(), values === null || values === void 0 ? void 0 : (_values$proposerDetai48 = values.proposerDetails) === null || _values$proposerDetai48 === void 0 ? void 0 : (_values$proposerDetai49 = _values$proposerDetai48.commState) === null || _values$proposerDetai49 === void 0 ? void 0 : _values$proposerDetai49.trim(), values === null || values === void 0 ? void 0 : (_values$proposerDetai50 = values.proposerDetails) === null || _values$proposerDetai50 === void 0 ? void 0 : _values$proposerDetai50.commPincode].filter(function (a) {
          return a;
        }).join(','));
      }
    }].filter(function (d) {
      return d;
    })
  }, proposerDetails.customerType === getDomainData(customerTypeList, 'Individual', 'value', 'code') ? {
    title: /*#__PURE__*/React.createElement(Text, {
      type: "normal",
      className: 'font-semibold'
    }, "Contact Details"),
    grid_type: 'input',
    clickToEdit: true,
    resetOnCancel: false,
    isBorderRequired: true,
    editDisplayDisabled: viewRenewPolicyData === null || viewRenewPolicyData === void 0 ? void 0 : viewRenewPolicyData.isProposalRenewed,
    disableSubmit: (values === null || values === void 0 ? void 0 : values.isCalculatingPremium) || ((_validate17 = validate(values)) === null || _validate17 === void 0 ? void 0 : (_validate17$proposerD = _validate17.proposerDetails) === null || _validate17$proposerD === void 0 ? void 0 : _validate17$proposerD.mobileNo) !== undefined || ((_validate18 = validate(values)) === null || _validate18 === void 0 ? void 0 : (_validate18$proposerD = _validate18.proposerDetails) === null || _validate18$proposerD === void 0 ? void 0 : _validate18$proposerD.emailID) !== undefined,
    disableEdit: values === null || values === void 0 ? void 0 : values.isCalculatingPremium,
    disableCancel: values === null || values === void 0 ? void 0 : values.isCalculatingPremium,
    borderClassName: 'border-t-2 border-neutral pt-2',
    initDisplayEdit: viewRenewPolicyData !== null && viewRenewPolicyData !== void 0 && viewRenewPolicyData.isProposalRenewed ? false : (_expandedCard$current36 = expandedCard.current.find(function (exp) {
      return (exp === null || exp === void 0 ? void 0 : exp.cardName) === 'proposerDetails';
    })) === null || _expandedCard$current36 === void 0 ? void 0 : (_expandedCard$current37 = _expandedCard$current36.subSections) === null || _expandedCard$current37 === void 0 ? void 0 : _expandedCard$current37.includes('contactDetails'),
    onValueChanges: function onValueChanges(values) {
      setValueChanges(values);
    },
    onEdit: function onEdit(_) {
      var _expandedCard$current38;

      setEnableRenew(false);
      setFieldValue("countEditsOpen", (values === null || values === void 0 ? void 0 : values.countEditsOpen) + 1);
      expandedCard.current = [].concat(_toConsumableArray(expandedCard.current.filter(function (exp) {
        return (exp === null || exp === void 0 ? void 0 : exp.cardName) !== 'proposerDetails';
      })), [_objectSpread2(_objectSpread2({}, expandedCard.current.find(function (exp) {
        return (exp === null || exp === void 0 ? void 0 : exp.cardName) === 'proposerDetails';
      })), {}, {
        cardFlag: true,
        subSections: [].concat(_toConsumableArray((_expandedCard$current38 = expandedCard.current.find(function (exp) {
          return (exp === null || exp === void 0 ? void 0 : exp.cardName) === 'proposerDetails';
        })) === null || _expandedCard$current38 === void 0 ? void 0 : _expandedCard$current38.subSections), ['contactDetails'])
      })]);

      if (props.forwardedAlertsRef && props.forwardedAlertsRef.current) {
        props.forwardedAlertsRef.current = [];
      }

      updateViewRenewPolicyData({
        isProposalReadyForRenewal: false
      });
      setProposerDetailsCardToggle(false);
    },
    onCancel: function onCancel(_, valuesBeforeEdit) {
      var _valuesBeforeEdit$pro29, _valuesBeforeEdit$pro30, _expandedCard$current39, _expandedCard$current40;

      if ((values === null || values === void 0 ? void 0 : values.countEditsOpen) === 1) {
        updateViewRenewPolicyData({
          isProposalReadyForRenewal: true
        });
        setEnableRenew(true);
      }

      setFieldValue("countEditsOpen", (values === null || values === void 0 ? void 0 : values.countEditsOpen) - 1);
      setFieldValue("proposerDetails.mobileNo", valuesBeforeEdit === null || valuesBeforeEdit === void 0 ? void 0 : (_valuesBeforeEdit$pro29 = valuesBeforeEdit.proposerDetails) === null || _valuesBeforeEdit$pro29 === void 0 ? void 0 : _valuesBeforeEdit$pro29.mobileNo);
      setFieldValue("proposerDetails.emailID", valuesBeforeEdit === null || valuesBeforeEdit === void 0 ? void 0 : (_valuesBeforeEdit$pro30 = valuesBeforeEdit.proposerDetails) === null || _valuesBeforeEdit$pro30 === void 0 ? void 0 : _valuesBeforeEdit$pro30.emailID);
      expandedCard.current = [].concat(_toConsumableArray(expandedCard.current.filter(function (exp) {
        return (exp === null || exp === void 0 ? void 0 : exp.cardName) !== 'proposerDetails';
      })), [_objectSpread2(_objectSpread2({}, expandedCard.current.find(function (exp) {
        return (exp === null || exp === void 0 ? void 0 : exp.cardName) === 'proposerDetails';
      })), {}, {
        cardFlag: false,
        subSections: _toConsumableArray((_expandedCard$current39 = expandedCard.current.find(function (exp) {
          return (exp === null || exp === void 0 ? void 0 : exp.cardName) === 'proposerDetails';
        })) === null || _expandedCard$current39 === void 0 ? void 0 : (_expandedCard$current40 = _expandedCard$current39.subSections) === null || _expandedCard$current40 === void 0 ? void 0 : _expandedCard$current40.filter(function (subSection) {
          return subSection !== 'contactDetails';
        }))
      })]);

      if (props.forwardedAlertsRef && props.forwardedAlertsRef.current) {
        props.forwardedAlertsRef.current = [];
      }

      setProposerDetailsCardToggle(true);
    },
    onSave: function onSave(_) {
      var _expandedCard$current41, _expandedCard$current42;

      if ((values === null || values === void 0 ? void 0 : values.countEditsOpen) === 1) {
        updateViewRenewPolicyData({
          isProposalReadyForRenewal: true
        });
        setEnableRenew(true);
      }

      setFieldValue("countEditsOpen", (values === null || values === void 0 ? void 0 : values.countEditsOpen) - 1);
      expandedCard.current = [].concat(_toConsumableArray(expandedCard.current.filter(function (exp) {
        return (exp === null || exp === void 0 ? void 0 : exp.cardName) !== 'proposerDetails';
      })), [_objectSpread2(_objectSpread2({}, expandedCard.current.find(function (exp) {
        return (exp === null || exp === void 0 ? void 0 : exp.cardName) === 'proposerDetails';
      })), {}, {
        cardFlag: false,
        subSections: _toConsumableArray((_expandedCard$current41 = expandedCard.current.find(function (exp) {
          return (exp === null || exp === void 0 ? void 0 : exp.cardName) === 'proposerDetails';
        })) === null || _expandedCard$current41 === void 0 ? void 0 : (_expandedCard$current42 = _expandedCard$current41.subSections) === null || _expandedCard$current42 === void 0 ? void 0 : _expandedCard$current42.filter(function (subSection) {
          return subSection !== 'contactDetails';
        }))
      })]);

      if (props.forwardedAlertsRef && props.forwardedAlertsRef.current) {
        props.forwardedAlertsRef.current = [];
      }

      setProposerDetailsCardToggle(true);
    },
    grid_data: [{
      type: 'text',
      maxLength: 10,
      onKeyDown: function onKeyDown(evt) {
        return evt.key === 'e' && evt.preventDefault();
      },
      label: /*#__PURE__*/React.createElement("div", null, "Mobile Number ", /*#__PURE__*/React.createElement(Text, {
        severity: "error"
      }, "*")),
      labelReadOnly: /*#__PURE__*/React.createElement("div", null, "Mobile Number ", /*#__PURE__*/React.createElement(Text, {
        severity: "error"
      })),
      name: 'proposerDetails.mobileNo',
      disabled: values === null || values === void 0 ? void 0 : values.isCalculatingPremium
    }, {
      type: 'email',
      label: /*#__PURE__*/React.createElement("div", null, "Email Id ", /*#__PURE__*/React.createElement(Text, {
        severity: "error"
      }, "*")),
      labelReadOnly: /*#__PURE__*/React.createElement("div", null, "Email Id ", /*#__PURE__*/React.createElement(Text, {
        severity: "error"
      })),
      name: 'proposerDetails.emailID',
      disabled: values === null || values === void 0 ? void 0 : values.isCalculatingPremium
    }].filter(function (d) {
      return d;
    })
  } : {
    title: /*#__PURE__*/React.createElement(Text, {
      type: "normal",
      className: 'font-semibold'
    }, "Contact Details"),
    grid_type: 'input',
    clickToEdit: true,
    editDisplayDisabled: viewRenewPolicyData === null || viewRenewPolicyData === void 0 ? void 0 : viewRenewPolicyData.isProposalRenewed,
    initDisplayEdit: viewRenewPolicyData !== null && viewRenewPolicyData !== void 0 && viewRenewPolicyData.isProposalRenewed ? false : (_expandedCard$current43 = expandedCard.current.find(function (exp) {
      return (exp === null || exp === void 0 ? void 0 : exp.cardName) === 'proposerDetails';
    })) === null || _expandedCard$current43 === void 0 ? void 0 : (_expandedCard$current44 = _expandedCard$current43.subSections) === null || _expandedCard$current44 === void 0 ? void 0 : _expandedCard$current44.includes('contactDetails'),
    onValueChanges: function onValueChanges(values) {
      setValueChanges(values);
    },
    onEdit: function onEdit(_) {
      var _expandedCard$current45, _expandedCard$current46;

      setEnableRenew(false);
      setFieldValue("countEditsOpen", (values === null || values === void 0 ? void 0 : values.countEditsOpen) + 1);
      expandedCard.current = [].concat(_toConsumableArray(expandedCard.current.filter(function (exp) {
        return (exp === null || exp === void 0 ? void 0 : exp.cardName) !== 'proposerDetails';
      })), [_objectSpread2(_objectSpread2({}, expandedCard.current.find(function (exp) {
        return (exp === null || exp === void 0 ? void 0 : exp.cardName) === 'proposerDetails';
      })), {}, {
        cardFlag: true,
        subSections: [].concat(_toConsumableArray(expandedCard === null || expandedCard === void 0 ? void 0 : (_expandedCard$current45 = expandedCard.current) === null || _expandedCard$current45 === void 0 ? void 0 : (_expandedCard$current46 = _expandedCard$current45.find(function (exp) {
          return (exp === null || exp === void 0 ? void 0 : exp.cardName) === 'proposerDetails';
        })) === null || _expandedCard$current46 === void 0 ? void 0 : _expandedCard$current46.subSections), ['contactDetails'])
      })]);

      if (props.forwardedAlertsRef && props.forwardedAlertsRef.current) {
        props.forwardedAlertsRef.current = [];
      }

      updateViewRenewPolicyData({
        isProposalReadyForRenewal: false
      });
      setProposerDetailsCardToggle(false);
    },
    onCancel: function onCancel(_, valuesBeforeEdit) {
      var _valuesBeforeEdit$pro31, _valuesBeforeEdit$pro32, _valuesBeforeEdit$pro33, _valuesBeforeEdit$pro34, _valuesBeforeEdit$pro35, _expandedCard$current47, _expandedCard$current48, _expandedCard$current49;

      if ((values === null || values === void 0 ? void 0 : values.countEditsOpen) === 1) {
        updateViewRenewPolicyData({
          isProposalReadyForRenewal: true
        });
        setEnableRenew(true);
      }

      setFieldValue("countEditsOpen", (values === null || values === void 0 ? void 0 : values.countEditsOpen) - 1);
      setFieldValue("proposerDetails.phoneNo", valuesBeforeEdit === null || valuesBeforeEdit === void 0 ? void 0 : (_valuesBeforeEdit$pro31 = valuesBeforeEdit.proposerDetails) === null || _valuesBeforeEdit$pro31 === void 0 ? void 0 : _valuesBeforeEdit$pro31.phoneNo);
      setFieldValue("proposerDetails.faxNo", valuesBeforeEdit === null || valuesBeforeEdit === void 0 ? void 0 : (_valuesBeforeEdit$pro32 = valuesBeforeEdit.proposerDetails) === null || _valuesBeforeEdit$pro32 === void 0 ? void 0 : _valuesBeforeEdit$pro32.faxNo);
      setFieldValue("proposerDetails.altMobileNo", valuesBeforeEdit === null || valuesBeforeEdit === void 0 ? void 0 : (_valuesBeforeEdit$pro33 = valuesBeforeEdit.proposerDetails) === null || _valuesBeforeEdit$pro33 === void 0 ? void 0 : _valuesBeforeEdit$pro33.altMobileNo);
      setFieldValue("proposerDetails.altPhoneNo", valuesBeforeEdit === null || valuesBeforeEdit === void 0 ? void 0 : (_valuesBeforeEdit$pro34 = valuesBeforeEdit.proposerDetails) === null || _valuesBeforeEdit$pro34 === void 0 ? void 0 : _valuesBeforeEdit$pro34.altPhoneNo);
      setFieldValue("proposerDetails.emailID", valuesBeforeEdit === null || valuesBeforeEdit === void 0 ? void 0 : (_valuesBeforeEdit$pro35 = valuesBeforeEdit.proposerDetails) === null || _valuesBeforeEdit$pro35 === void 0 ? void 0 : _valuesBeforeEdit$pro35.emailID);
      expandedCard.current = [].concat(_toConsumableArray(expandedCard.current.filter(function (exp) {
        return (exp === null || exp === void 0 ? void 0 : exp.cardName) !== 'proposerDetails';
      })), [_objectSpread2(_objectSpread2({}, expandedCard.current.find(function (exp) {
        return (exp === null || exp === void 0 ? void 0 : exp.cardName) === 'proposerDetails';
      })), {}, {
        cardFlag: false,
        subSections: _toConsumableArray(expandedCard === null || expandedCard === void 0 ? void 0 : (_expandedCard$current47 = expandedCard.current) === null || _expandedCard$current47 === void 0 ? void 0 : (_expandedCard$current48 = _expandedCard$current47.find(function (exp) {
          return (exp === null || exp === void 0 ? void 0 : exp.cardName) === 'proposerDetails';
        })) === null || _expandedCard$current48 === void 0 ? void 0 : (_expandedCard$current49 = _expandedCard$current48.subSections) === null || _expandedCard$current49 === void 0 ? void 0 : _expandedCard$current49.filter(function (subSection) {
          return subSection !== 'contactDetails';
        }))
      })]);

      if (props.forwardedAlertsRef && props.forwardedAlertsRef.current) {
        props.forwardedAlertsRef.current = [];
      }

      setProposerDetailsCardToggle(true);
    },
    onSave: function onSave(_) {
      var _expandedCard$current50, _expandedCard$current51, _expandedCard$current52;

      if ((values === null || values === void 0 ? void 0 : values.countEditsOpen) === 1) {
        updateViewRenewPolicyData({
          isProposalReadyForRenewal: true
        });
        setEnableRenew(true);
      }

      setFieldValue("countEditsOpen", (values === null || values === void 0 ? void 0 : values.countEditsOpen) - 1);
      expandedCard.current = [].concat(_toConsumableArray(expandedCard.current.filter(function (exp) {
        return (exp === null || exp === void 0 ? void 0 : exp.cardName) !== 'proposerDetails';
      })), [_objectSpread2(_objectSpread2({}, expandedCard.current.find(function (exp) {
        return (exp === null || exp === void 0 ? void 0 : exp.cardName) === 'proposerDetails';
      })), {}, {
        cardFlag: false,
        subSections: _toConsumableArray(expandedCard === null || expandedCard === void 0 ? void 0 : (_expandedCard$current50 = expandedCard.current) === null || _expandedCard$current50 === void 0 ? void 0 : (_expandedCard$current51 = _expandedCard$current50.find(function (exp) {
          return (exp === null || exp === void 0 ? void 0 : exp.cardName) === 'proposerDetails';
        })) === null || _expandedCard$current51 === void 0 ? void 0 : (_expandedCard$current52 = _expandedCard$current51.subSections) === null || _expandedCard$current52 === void 0 ? void 0 : _expandedCard$current52.filter(function (subSection) {
          return subSection !== 'contactDetails';
        }))
      })]);

      if (props.forwardedAlertsRef && props.forwardedAlertsRef.current) {
        props.forwardedAlertsRef.current = [];
      }

      setProposerDetailsCardToggle(true);
    },
    disableSubmit: (values === null || values === void 0 ? void 0 : values.isCalculatingPremium) || ((_validate19 = validate(values)) === null || _validate19 === void 0 ? void 0 : (_validate19$proposerD = _validate19.proposerDetails) === null || _validate19$proposerD === void 0 ? void 0 : _validate19$proposerD.mobileNo) !== undefined || ((_validate20 = validate(values)) === null || _validate20 === void 0 ? void 0 : (_validate20$proposerD = _validate20.proposerDetails) === null || _validate20$proposerD === void 0 ? void 0 : _validate20$proposerD.emailID) !== undefined,
    disableEdit: values === null || values === void 0 ? void 0 : values.isCalculatingPremium,
    disableCancel: values === null || values === void 0 ? void 0 : values.isCalculatingPremium,
    resetOnCancel: false,
    isBorderRequired: true,
    borderClassName: 'border-t-2 border-neutral pt-2',
    grid_data: [{
      type: 'number',
      min: 0,
      onKeyDown: function onKeyDown(evt) {
        return (evt.key === 'e' || evt.key === '.') && evt.preventDefault();
      },
      label: /*#__PURE__*/React.createElement("div", null, "Telephone Number ", /*#__PURE__*/React.createElement(Text, null)),
      name: 'proposerDetails.phoneNo',
      disabled: values === null || values === void 0 ? void 0 : values.isCalculatingPremium
    }, {
      type: 'text',
      maxLength: 10,
      onKeyDown: function onKeyDown(evt) {
        return (evt.key === 'e' || evt.key === '.') && evt.preventDefault();
      },
      label: /*#__PURE__*/React.createElement("div", null, "Organisation Mobile Number", ' ', /*#__PURE__*/React.createElement(Text, {
        severity: "error"
      }, "*")),
      labelReadOnly: /*#__PURE__*/React.createElement("div", null, "Organisation Mobile Number ", /*#__PURE__*/React.createElement(Text, null)),
      name: 'proposerDetails.mobileNo',
      disabled: values === null || values === void 0 ? void 0 : values.isCalculatingPremium
    }, {
      type: 'number',
      min: 0,
      onKeyDown: function onKeyDown(evt) {
        return evt.key === 'e' && evt.preventDefault();
      },
      label: /*#__PURE__*/React.createElement("div", null, "FAX Number ", /*#__PURE__*/React.createElement(Text, null)),
      name: 'proposerDetails.faxNo',
      disabled: values === null || values === void 0 ? void 0 : values.isCalculatingPremium
    }, {
      type: 'number',
      min: 0,
      onKeyDown: function onKeyDown(evt) {
        return (evt.key === 'e' || evt.key === '.') && evt.preventDefault();
      },
      label: /*#__PURE__*/React.createElement("div", null, "Alternative Telephone Number ", /*#__PURE__*/React.createElement(Text, null)),
      name: 'proposerDetails.altPhoneNo',
      disabled: values === null || values === void 0 ? void 0 : values.isCalculatingPremium
    }, {
      type: 'text',
      maxLength: 10,
      onKeyDown: function onKeyDown(evt) {
        return (evt.key === 'e' || evt.key === '.') && evt.preventDefault();
      },
      label: /*#__PURE__*/React.createElement("div", null, "Alternative Mobile Number ", /*#__PURE__*/React.createElement(Text, null)),
      name: 'proposerDetails.altMobileNo',
      disabled: values === null || values === void 0 ? void 0 : values.isCalculatingPremium
    }, {
      type: 'email',
      label: /*#__PURE__*/React.createElement("div", null, "Organisation Email Id", ' ', /*#__PURE__*/React.createElement(Text, {
        severity: "error"
      }, "*")),
      labelReadOnly: /*#__PURE__*/React.createElement("div", null, "Organisation Email Id ", /*#__PURE__*/React.createElement(Text, null)),
      name: 'proposerDetails.emailID',
      disabled: values === null || values === void 0 ? void 0 : values.isCalculatingPremium
    }].filter(function (d) {
      return d;
    })
  }].filter(function (d) {
    return d;
  }) : [];
  return proposerCustomerData;
}

export { ProposerCustomerEditable as P };
